/*! TechSmithMediaLibJS - v0.17.0 - 2015-12-17 */(function (root) {
   "use strict";

   /**
    * tscml JavaScript namespace.
    * @namespace tscml
    */
   if (typeof exports === 'undefined') {
      root.tscml = root.tscml || {};
   }

})(this);

(function (root, additionalPropertyHelperFactory) {
   "use strict";

   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.AdditionalPropertyHelper = additionalPropertyHelperFactory(root);

})(this, function (root) {

   "use strict";
   return {
      /**
       *  Parse additonal properties that were not in the handledProperties object and return them as a JSON object.
       *  @memberof tscml.AdditionalPropertyHelper
       *  @function parseAdditionalProperties
       *  @param {object} handledProperties - properties that were already handled by the caller
       *  @param {object} jsonObject - the json object to inspect
       *  @param {function} foundPropertyCallback - the callback to call when an additional property is encountered. It has the format 'function(key, value)'
       *  @return {tscml.AdditionalPropertyHelper} A new AdditionalPropertyHelper Object
       */
      parseAdditionalProperties: function (handledProperties, jsonObject, foundPropertyCallback) {
         if (typeof handledProperties != "object" || typeof jsonObject != "object" || typeof foundPropertyCallback != "function") {
            throw new Error("AdditionalPropertyHelper: expected two object parameters and one function but instead got: " + handledProperties + " and " + jsonObject + " and " + foundPropertyCallback);
         }

         var additionalProperties = {};
         for (var prop in jsonObject) {
            if (jsonObject.hasOwnProperty(prop) && handledProperties.indexOf(prop) === -1) {
               foundPropertyCallback(prop, jsonObject[prop]);
            }
         }

         return additionalProperties;
      },

      /**
       *  Add all properties passed in to the passed in json object.
       *  @memberof tscml.AdditionalPropertyHelper
       *  @function parseAdditionalProperties
       *  @param {object} || - properties too add to the object
       *  @param {object} jsonObject - the json object to inspect
       */
      updatePropertiesOnObject: function (properties, jsonObject) {
         if (typeof properties != "object" || typeof jsonObject != "object") {
            throw new Error("AdditionalPropertyHelper: expected two object parameters but instead got: " + properties + " and " + jsonObject);
         }

         for (var prop in properties) {
            if (properties.hasOwnProperty(prop)) {
               jsonObject[prop] = properties[prop];
            }
         }
      }
   };
});

(function (root, sceneTypeFactory) {
   "use strict";

   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.sceneType = sceneTypeFactory(root);

})(this, function (root) {

   "use strict";

   /**
    * @memberof tscml
    * @class sceneType
    */
   var sceneType = function () {
      return Object.defineProperties({}, {
         /**
          * @constant
          * @type {string}
          * @memberof tscml.sceneType
          */
         EMPTY: {
            value: ""
         },
         /**
          * @constant
          * @type {string}
          * @memberof tscml.sceneType
          */
         CONTENT: {
            value: "content"
         },
         /**
          * @constant
          * @type {string}
          * @memberof tscml.sceneType
          */
         TITLE: {
            value: "title"
         },
         /**
          * @constant
          * @type {string}
          * @memberof tscml.sceneType
          */
         INTRO: {
            value: "intro"
         },
         /**
          * @constant
          * @type {string}
          * @memberof tscml.sceneType
          */
         OUTRO: {
            value: "outro"
         }
      });
   };

   return sceneType();

});

(function (root, defaultSceneValuesFactory) {
   "use strict";

   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.defaultSceneValues = defaultSceneValuesFactory(root, namespace.sceneType);

})(this, function (root, sceneType) {

   "use strict";

   /**
    * @memberof tscml
    * @constant {Object} defaultSceneValues - Default values for a Scene
    */

   return Object.defineProperties({}, {
      /**
       * Default title for a Scene
       * @constant
       * @type {string}
       * @memberof tscml.defaultSceneValues
       */
      TITLE: {
         value: ""
      },
      /**
       * Default duration for a Scene
       * @constant
       * @type {Number}
       * @memberof tscml.defaultSceneValues
       */
      DURATION: {
         value: 2
      },
      /**
       * Default type for a Scene
       * @constant
       * @type {string}
       * @memberof tscml.defaultSceneValues
       */
      TYPE: {
         value: sceneType.EMPTY
      }
   });
});

(function (root, eventsFactory) {
   "use strict";

   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.EventDispatcher = eventsFactory(root);

})(this, function (root) {

   "use strict";

   /**
    * @memberof tscml
    * @class EventDispatcher
    * @param {Object} dispatcherInterface - Interface to queue events.
    * @classdesc Utility class used to allow client code to register for events on a particular object.
    */
   var EventDispatcher = function (dispatcherInterface) {

      var _events = {};

      var notifyListeners = function (eventEntry, data) {
         eventEntry.forEach(function (event) {
            event(data);
         });
      };

      var genNotifyFn = function (eventName, data) {
         return function () {
            notifyListeners(_events[eventName], data);
         };
      };

      return {
         /**
          *  Add a callback function for an event.
          *  @memberof tscml.EventDispatcher
          *  @function on
          *  @param {String} eventName - Name of event to listen for.
          *  @param {Function} callback - Callback function for event.
          */
         on: function (eventName, callback) {
            if (typeof eventName != "string" || typeof callback != "function") {
               throw new Error("EventDispatcher.on expects string for the eventName and a callback function.");
            }
            if (!_events[eventName]) {
               _events[eventName] = [];
            }
            _events[eventName].push(callback);
         },
         /**
          *  Remove a callback function for an event.
          *  @memberof tscml.EventDispatcher
          *  @function off
          *  @param {String} eventName - Name of event to listen for.
          *  @param {Function} callback - Callback function for event.
          */
         off: function (eventName, callback) {
            var eventEntry = _events[eventName];
            if (eventEntry) {
               for (var i = 0; i < eventEntry.length; i++) {
                  if (eventEntry[i] === callback) {
                     eventEntry.splice(i, 1);
                     break;
                  }
               }
               if (eventEntry.length === 0) {
                  _events[eventName] = undefined;
               }
            }
         },
         /**
          *  Trigger the event.
          *  @memberof tscml.EventDispatcher
          *  @function trigger
          *  @param {String} eventName - Name of event to trigger.
          *  @param {Object} data - Event data.
          */
         trigger: function (eventName, data) {
            data = data || {};
            if (typeof eventName != "string") {
               throw new Error("EventDispatcher.trigger expects string for the eventName.");
            }

            if (_events[eventName]) {
               data.type = eventName;
               if (dispatcherInterface.isActive()) {
                  dispatcherInterface.queueNotification(genNotifyFn(eventName, data));
               } else {
                  notifyListeners(_events[eventName], data);
               }
            }
         }
      };
   };

   return {
      /**
       *  Factory method that returns a new EventDispatcher object.
       *  @function create
       *  @memberof tscml.EventDispatcher
       *  @param {Object} dispatcherInterface - Interface to queue events.
       *  @static
       *  @return {tscml.EventDispatcher} new EventDispatcher instance
       */
      create: function (dispatcherInterface) {
         return new EventDispatcher(dispatcherInterface);
      }
   };
});

(function (root, eventNotificationBundlerFactory) {
   "use strict";

   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.EventNotificationBundler = eventNotificationBundlerFactory(root, namespace.EventDispatcher);

})(this, function (root, EventDispatcher) {

   "use strict";

   /**
    * @memberof tscml
    * @class EventNotificationBundler
    * @classdesc The bundler collects notifications sent by model objects and dispatched them in batch
    * when flushed.
    */
   var EventNotificationBundler = function () {
      var _notificationQueue,
         _isActive,
         _dispatcherInterface;

      _notificationQueue = [];
      _isActive = false;

      _dispatcherInterface = {
         queueNotification: function (notifyFn) {
            _notificationQueue.push(notifyFn);
         },
         isActive: function () {
            return _isActive;
         }
      };

      return {
         /**
          *  Create a new EventDispatcher Object.
          *  @memberof tscml.EventNotificationBundler
          *  @function eventDispatcherFactory
          *  @return {tscml.EventDispatcher} A new EventDispatcher Object
          */
         eventDispatcherFactory: function () {
            return EventDispatcher.create(_dispatcherInterface);
         },
         /**
          *  When called, all events will start being added to a queue until flushEvents or reset are called.
          *  @memberof tscml.EventNotificationBundler
          *  @function startBundling
          */
         startBundling: function () {
            if (_isActive) {
               this.flushEvents();
            }
            _isActive = true;
         },
         /**
          *  Removes all queued events and turns off bundling.
          *  @memberof tscml.EventNotificationBundler
          *  @function reset
          */
         reset: function () {
            _notificationQueue = [];
            _isActive = false;
         },
         /**
          *  Calls all bundled events and turns off bundling.
          *  @memberof tscml.EventNotificationBundler
          *  @function flushEvents
          */
         flushEvents: function () {
            _notificationQueue.forEach(function (executeEvent) {
               try {
                  executeEvent();
               } catch (error) {
                  console.error("tscml.EventNotificationBundler - flushEvents: ", error);
               }
            });
            this.reset();
         }
      };
   };

   return {
      /**
       *  Factory method that returns a new EventNotificationBundler object.
       *  @function create
       *  @memberof tscml.EventNotificationBundler
       *  @static
       *  @return {tscml.EventNotificationBundler} new EventNotificationBundler instance
       */
      create: function () {
         return new EventNotificationBundler();
      }
   };
});

(function (root, idGeneratorFactory) {
   "use strict";

   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.idGenerator = idGeneratorFactory();

})(this, function () {

   "use strict";

   /**
    * @memberof tscml
    * @class idGenerator
    * @classdesc Class will generate a new id every time you request one.
    */
   var idGenerator = function () {

      // src: http://slavik.meltser.info/the-efficient-way-to-create-guid-uuid-in-javascript-with-explanation/
      function guid() {
         function _p8(s) {
            var p = (Math.random().toString(16) + "000000000").substr(2, 8);
            return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
         }

         return _p8() + _p8(true) + _p8(true) + _p8();
      }

      return {
         /**
          *  This method will return either a passed id or a new unique id.
          *  @function registerObject
          *  @param {String} id - Optional id to use for the object.
          *  @memberof tscml.idGenerator
          *  @return {String} A unique id.
          */
         registerObject: function (id) {
            if (typeof id !== 'undefined') {
               return id;
            } else {
               return guid();
            }
         }
      };
   };

   return idGenerator();

});

(function (root, projectSignatureGeneratorFactory) {
   "use strict";

   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.projectSignatureGenerator = projectSignatureGeneratorFactory(root);

})(this, function (root) {

   "use strict";

   /**
    * @memberof tscml
    * @class projectSignatureGenerator
    * @classdesc Project Signature Generator class
    */
   var projectSignatureGenerator = function () {
      return {
         /**
          *  Generate a random number used to sign project.
          *  @memberof tscml.projectSignatureGenerator
          *  @function generate
          *  @return {Number}
          */
         generate: function () {
            return Math.floor(Math.random() * 100000);
         }
      };
   };

   return projectSignatureGenerator();

});

(function (root, sourceFactory) {
   "use strict";

   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.Source = sourceFactory(root, namespace.idGenerator, namespace.AdditionalPropertyHelper);

})(this, function (root, idGenerator, AdditionalPropertyHelper) {

   "use strict";

   /**
    * @memberof tscml
    * @class Source
    * @classdesc Represents a media source.
    * @param {Object} params
    * @param {String} [params.id] - Optional id for existing timeline.
    * @param {String} [params.uri] - Uri of media source.
    * @param {Number} [params.duration] - Duration of media source.
    * @param {String} [params.mimeType] - Mime type of media source.
    */
   var Source = function (params) {
      var _id,
         _uri,
         _duration,
         _mimeType,
         _public,
         _projectSignature,
         _additionalProperties;

      var durationAsFloat = parseFloat(params.duration);
      if (isNaN(durationAsFloat)) {
         throw new Error("Scene source duration could not be converted to a number.");
      }

      _projectSignature = params.projectSignature;
      _id = idGenerator.registerObject(params.id);
      _uri = params.uri;
      _duration = durationAsFloat;
      _mimeType = params.mimeType;
      _additionalProperties = {};

      var addAdditionalProperty = function (name, value) {
         _additionalProperties[name] = value;
      };

      var setMimeType = function(mimeType) {
         _mimeType = mimeType;
      };

      // public properties
      _public = Object.defineProperties({},
         {
            /**
             *  @public
             *  @readonly
             *  @memberof tscml.Source
             *  @property {String} id - Unique id for this object.
             */
            id: {
               value: _id
            },
            /**
             *  @public
             *  @readonly
             *  @memberof tscml.Source
             *  @property {String} uri - Uri to a media source.
             */
            uri: {
               value: _uri
            },
            /**
             *  @public
             *  @readonly
             *  @memberof tscml.Source
             *  @property {Number} duration - Duration of the Source.
             */
            duration: {
               value: _duration
            },
            /**
             *  @public
             *  @readonly
             *  @memberof tscml.Source
             *  @property {String} mimeType - Mime type of the source.
             */
            mimeType: {
               get: function() {
                  return _mimeType;
               }
            }
         }
      );

      /**
       *  Get an object with access to a Source manipulation methods.  This is used internally within Media Lib.
       *  @memberof tscml.Source
       *  @function getCommandInterface
       *  @param {Number} projectSignature - Project signature produced to control access.
       *  @return {Object}
       */
      _public.getCommandInterface = function (projectSignature) {
         if (_projectSignature !== projectSignature) {
            throw new Error("Tried to get command interface with invalid project signature");
         }
         return {
            addAdditionalProperty: addAdditionalProperty,
            setMimeType: setMimeType
         };
      };

      /**
       *  Will return the JSON for the source object
       *  @function toJSON
       *  @memberof tscml.Source
       *  @return {Object}
       */
      _public.toJSON = function () {
         var json = {
            id: _id,
            uri: _uri,
            mimeType: _mimeType
         };

         if (_additionalProperties) {
            AdditionalPropertyHelper.updatePropertiesOnObject(_additionalProperties, json);
         }

         return json;
      };

      /**
       *  Will return a new copy of the Source instance with a unique id.
       *  @function clone
       *  @memberof tscml.Source
       *  @return {tscml.Source} new Source instance
       */
      _public.clone = function () {
         var sourceParams = {
            uri: params.uri,
            duration: params.duration,
            mimeType: params.mimeType
         };
         return new Source(sourceParams);
      };

      return _public;
   };

   return {
      /**
       *  Factory method that returns a new Source object.
       *  @function create
       *  @memberof tscml.Source
       *  @param {Object} params
       *  @param {String} [params.id] - Optional id for existing timeline.
       *  @param {String} [params.uri] - Uri of media source.
       *  @param {Number} [params.duration] - Duration of media source.
       *  @param {String} [params.mimeType] - Mime type of media source.
       *  @param {Number} [params.projectSignature] - Project signature used to control access to command interface.
       *  @static
       *  @return {tscml.Source} new Source instance
       */
      create: function (params) {
         return new Source(params);
      }
   };

});

(function (root, emptySceneFactory) {
   "use strict";

   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.EmptyScene = emptySceneFactory(root, namespace.AdditionalPropertyHelper);

})(this, function (root, AdditionalPropertyHelper) {

   "use strict";

   /**
    * @memberof tscml
    * @class EmptyScene
    * @classdesc Themeable scene extends scene class for empty scenes. EmptyScene is used internally by Scene.
    * @param {tscml.Scene} scene - Scene instance to extend.
    * @param {Object} params
    * @param {Number} params.projectSignature - Project signature used to control access to command interface.
    * @param {tscml.EventDispatcher} params.eventDispatcher - Event dispatcher instance.
    * @fires tscml.Scene#sceneTypeChange
    * @borrows tscml.Scene.id as id
    * @borrows tscml.Scene.type as type
    * @borrows tscml.Scene.title as title
    * @borrows tscml.Scene.duration as duration
    * @borrows tscml.Scene.sceneTrack as sceneTrack
    * @borrows tscml.Scene.clone as clone
    */
   var EmptyScene = function (scene, params) {
      var _projectSignature,
         _additionalProperties,
         _eventDispatcher,
         _commandInterface;

      _projectSignature = params.projectSignature;
      _eventDispatcher = params.eventDispatcher;
      _additionalProperties = {};

      var buildCommandInterface = function () {
         _commandInterface = scene.getCommandInterface(_projectSignature);
         _commandInterface.addAdditionalProperty = addAdditionalProperty;
      };

      var addAdditionalProperty = function (name, value) {
         _additionalProperties[name] = value;
      };

      buildCommandInterface();

      /**
       *  Get an object with access to a Content Scenes manipulation methods.  This is used internally within Media Lib.
       *  @memberof tscml.EmptyScene
       *  @function getCommandInterface
       *  @param {Number} projectSignature - Project signature produced to control access.
       *  @return {Object}
       */
      scene.getCommandInterface = function (projectSignature) {
         if (_projectSignature !== projectSignature) {
            throw new Error("Tried to get command interface with invalid project signature");
         }
         return _commandInterface;
      };

      /**
       *  Add a callback function for an event.
       *  @memberof tscml.EmptyScene
       *  @function on
       *  @param {String} eventName - Name of event to listen for.
       *  @param {Function} callback - Callback function for event.
       */
      scene.on = _eventDispatcher.on;

      /**
       *  Remove a callback function for an event.
       *  @memberof tscml.EmptyScene
       *  @function off
       *  @param {String} eventName - Name of event to listen for.
       *  @param {Function} callback - Callback function for event.
       */
      scene.off = _eventDispatcher.off;

      /**
       *  Will return the JSON for the Scene object
       *  @function toJSON
       *  @memberof tscml.EmptyScene
       *  @return {Object}
       */
      scene.toJSON = function () {
         var json = {
            id: scene.id,
            type: scene.type,
            title: scene.title,
            duration: scene.duration
         };

         if (_additionalProperties) {
            AdditionalPropertyHelper.updatePropertiesOnObject(_additionalProperties, json);
         }

         return json;
      };

      /**
       * Internally used methods
       */
      scene.cloneSceneContent = function (sceneClone) {
         return sceneClone;
      };

      return scene;
   };

   return {
      /**
       *  Factory method that returns a new EmptyScene object.
       *  @function create
       *  @memberof tscml.EmptyScene
       *  @param {tscml.Scene} scene - Scene instance to extend.
       *  @param {Object} params
       *  @param {Number} params.projectSignature - Project signature used to control access to command interface.
       *  @param {tscml.EventDispatcher} params.eventDispatcher - Event dispatcher instance.
       *  @static
       *  @return new EmptyScene instance
       */
      create: function (scene, params) {
         return new EmptyScene(scene, params);
      },
      /**
       *  Method will destroy property and methods decorated by empty scene on passed scene object.
       *  @function destroy
       *  @memberof tscml.EmptyScene
       *  @static
       *  @param {tscml.Scene} scene - Scene instance to destroy.
       */
      destroy: function(scene) {
         scene.getCommandInterface = undefined;
         scene.on = undefined;
         scene.off = undefined;
         scene.toJSON = undefined;
         scene.cloneSceneContent = undefined;
      }
   };
});

(function (root, contentSceneFactory) {
   "use strict";

   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.ContentScene = contentSceneFactory(root, namespace.AdditionalPropertyHelper);

})(this, function (root, AdditionalPropertyHelper) {

   "use strict";

   /**
    * Source added event fires when a Source is added to a Content Scene.
    * @event tscml.ContentScene#sourceAdded
    * @type {object}
    * @property {String} type - Event name
    * @property {tscml.Source} source - Source added to Scene.
    */

   /**
    * Source removed event fires when a Source is removed from a Content Scene.
    * @event tscml.ContentScene#sourceRemoved
    * @type {object}
    * @property {String} type - Event name
    * @property {tscml.Source} source - Source removed from Scene.
    */

   /**
    * @memberof tscml
    * @class ContentScene
    * @classdesc Content scene extends scene class for Scenes of type 'Content'.  ContentScene is used internally by Scene.
    * @param {tscml.Scene} scene - Scene instance to extend.
    * @param {Object} params
    * @param {Number} params.projectSignature - Project signature used to control access to command interface.
    * @param {tscml.EventDispatcher} params.eventDispatcher - Event dispatcher instance.
    * @fires tscml.ContentScene#sourceAdded
    * @fires tscml.ContentScene#sourceRemoved
    * @fires tscml.Scene#audioNarrationChange
    * @fires tscml.Scene#audioNarrationRemoved
    * @fires tscml.Scene#sceneTypeChange
    * @borrows tscml.Scene.id as id
    * @borrows tscml.Scene.type as type
    * @borrows tscml.Scene.title as title
    * @borrows tscml.Scene.duration as duration
    * @borrows tscml.Scene.sceneTrack as sceneTrack
    * @borrows tscml.Scene.clone as clone
    */
   var ContentScene = function (scene, params) {
      var _projectSignature,
         _sources,
         _additionalProperties = {},
         _eventDispatcher,
         _commandInterface;

      _sources = [];
      _projectSignature = params.projectSignature;
      _eventDispatcher = params.eventDispatcher;

      var buildCommandInterface = function () {
         _commandInterface = scene.getCommandInterface(_projectSignature);
         _commandInterface.addSource = addSource;
         _commandInterface.removeSource = removeSource;
         _commandInterface.addAdditionalProperty = addAdditionalProperty;
      };

      var isUriUniqueToScene = function (uri) {
         for (var i = 0; i < _sources.length; i++) {
            if (_sources[i].uri === uri) {
               return false;
            }
         }
         return true;
      };

      var addSource = function (source) {
         if (isUriUniqueToScene(source.uri)) {
            _sources.push(source);
            _eventDispatcher.trigger("sourceAdded", {source: source});
         } else {
            throw new Error("Scene already contains a source with uri: " + source.uri);
         }
      };

      var removeSource = function (source) {
         for (var i = 0; i < _sources.length; i++) {
            if (_sources[i] === source) {
               var removedSource = _sources.splice(i, 1)[0];
               _eventDispatcher.trigger("sourceRemoved", {source: removedSource});
               return removedSource;
            }
         }
      };

      var addAdditionalProperty = function (name, value) {
         _additionalProperties[name] = value;
      };

      buildCommandInterface();

      // public properties
      Object.defineProperties(scene,
         {
            /**
             *  @public
             *  @readonly
             *  @memberof tscml.ContentScene
             *  @property {Array.<tscml.Source>} sources - List of sources.
             */
            sources: {
               configurable: true,
               get: function () {
                  return [].concat(_sources);
               }
            }
         }
      );

      /**
       *  Get an object with access to a Content Scenes manipulation methods.  This is used internally within Media Lib.
       *  @memberof tscml.ContentScene
       *  @function getCommandInterface
       *  @param {Number} projectSignature - Project signature produced to control access.
       *  @return {Object}
       */
      scene.getCommandInterface = function (projectSignature) {
         if (_projectSignature !== projectSignature) {
            throw new Error("Tried to get command interface with invalid project signature");
         }
         return _commandInterface;
      };

      /**
       *  Add a callback function for an event.  Dispatches events: 'sourceAdded' 'sourceRemoved'
       *  @memberof tscml.ContentScene
       *  @function on
       *  @param {String} eventName - Name of event to listen for.
       *  @param {Function} callback - Callback function for event.
       *  @listens tscml.ContentScene#sourceAdded
       *  @listens tscml.ContentScene#sourceRemoved
       *  @listens tscml.Scene#audioNarrationChange
       *  @listens tscml.Scene#audioNarrationRemoved
       *  @example
       *  var onSourceAdded = function() {};
       *  var onSourceRemoved = function() {};
       *  project.timeline.sceneTrack.scenes[0].on('sourceAdded', onSourceAdded);
       *  project.timeline.sceneTrack.scenes[0].on('sourceRemoved', onSourceRemoved);
       */
      scene.on = _eventDispatcher.on;

      /**
       *  Remove a callback function for an event.  Dispatches events: 'sourceAdded' 'sourceRemoved'
       *  @memberof tscml.ContentScene
       *  @function off
       *  @param {String} eventName - Name of event to listen for.
       *  @param {Function} callback - Callback function for event.
       *  @example
       *  var onSourceAdded = function() {};
       *  var onSourceRemoved = function() {};
       *  project.timeline.sceneTrack.scenes[0].off('sourceAdded', onSourceAdded);
       *  project.timeline.sceneTrack.scenes[0].off('sourceRemoved', onSourceRemoved);
       */
      scene.off = _eventDispatcher.off;

      /**
       *  Get a source object with a specific mime type.
       *  @memberof tscml.ContentScene
       *  @function getSourceByMimeType
       *  @param {String} mimeType - Mime type of source requested.
       *  @return {tscml.Source} Source object.
       */
      scene.getSourceByMimeType = function (mimeType) {
         for (var i = 0, numSources = _sources.length; i < numSources; i++) {
            if (_sources[i].mimeType === mimeType) {
               return _sources[i];
            }
         }
      };

      /**
       *  Will return the JSON for the Scene object
       *  @function toJSON
       *  @memberof tscml.ContentScene
       *  @return {Object}
       */
      scene.toJSON = function () {
         var json = {
            id: scene.id,
            type: scene.type,
            title: scene.title,
            duration: scene.duration,
            flattenedSources: _sources.map(function (source) {
               return source.toJSON();
            })
         };

         if(scene.audioNarration !== null) {
            json.audioNarration = {
               id: scene.audioNarration.id,
               uri: scene.audioNarration.uri,
               mimeType: scene.audioNarration.mimeType
            };
         }

         if (_additionalProperties) {
            AdditionalPropertyHelper.updatePropertiesOnObject(_additionalProperties, json);
         }

         return json;
      };

      /**
       * Internally used method
       */
      scene.cloneSceneContent = function (sceneClone) {
         var commandInterface = sceneClone.getCommandInterface(_projectSignature);
         _sources.forEach(function (source) {
            commandInterface.addSource(source.clone());
         });
         return sceneClone;
      };

      return scene;
   };

   return {
      /**
       *  Factory method that returns a new ContentScene object.
       *  @function create
       *  @memberof tscml.ContentScene
       *  @static
       *  @param {tscml.Scene} scene - Scene instance to extend.
       *  @param {Object} params
       *  @param {Number} params.projectSignature - Project signature used to control access to command interface.
       *  @param {tscml.EventDispatcher} params.eventDispatcher - Event dispatcher instance.
       *  @return new ContentScene instance
       */
      create: function (scene, params) {
         return new ContentScene(scene, params);
      },
      /**
       *  Method will destroy property and methods decorated by content scene on passed scene object.
       *  @function destroy
       *  @memberof tscml.ContentScene
       *  @static
       *  @param {tscml.Scene} scene - Scene instance to destroy.
       */
      destroy: function(scene) {
         delete scene.sources;
         scene.getCommandInterface = undefined;
         scene.on = undefined;
         scene.off = undefined;
         scene.getSourceByMimeType = undefined;
         scene.toJSON = undefined;
         scene.cloneSceneContent = undefined;
      }
   };
});

(function (root, themeableSceneFactory) {
   "use strict";

   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.ThemeableScene = themeableSceneFactory(root, namespace.AdditionalPropertyHelper);

})(this, function (root, AdditionalPropertyHelper) {

   "use strict";

   /**
    * Theme tag def property change event fires when value changes for theme tag def property.
    * @event tscml.ThemeableScene#themeTagDefPropertyChange
    * @type {object}
    * @property {String} type - Event name
    * @property {String} themeTag - Theme tag with changed property.
    * @property {String} defProperty - Def property that changed.
    * @property {String|Number|Boolean} value - New property value.
    */

   /**
    * @memberof tscml
    * @class ThemeableScene
    * @classdesc Themeable scene extends scene class for scenes that support themeable properties.  ThemeableScene is used internally by Scene.
    * @param {tscml.Scene} scene - Scene instance to extend.
    * @param {Object} params
    * @param {Number} params.projectSignature - Project signature used to control access to command interface.
    * @param {tscml.EventDispatcher} params.eventDispatcher - Event dispatcher instance.
    * @param {Array.<Object>} params.themeables - Object of themeable items.
    * @fires tscml.ThemeableScene#themeTagDefPropertyChange
    * @fires tscml.Scene#audioNarrationChange
    * @fires tscml.Scene#audioNarrationRemoved
    * @fires tscml.Scene#sceneTypeChange
    * @borrows tscml.Scene.id as id
    * @borrows tscml.Scene.type as type
    * @borrows tscml.Scene.title as title
    * @borrows tscml.Scene.duration as duration
    * @borrows tscml.Scene.sceneTrack as sceneTrack
    * @borrows tscml.Scene.clone as clone
    */
   var ThemeableScene = function (scene, params) {
      var _projectSignature,
         _eventDispatcher,
         _themeables,
         _themeablesLookup,
         _additionalProperties,
         _commandInterface;

      _projectSignature = params.projectSignature;
      _eventDispatcher = params.eventDispatcher;
      _themeables = params.themeables || [];
      _additionalProperties = {};

      var optimizeThemeablesLookup = function () {
         _themeablesLookup = {};
         for (var i = 0, len = _themeables.length; i < len; i++) {
            _themeablesLookup[_themeables[i].themeTag] = _themeables[i];
         }
      };

      var buildCommandInterface = function () {
         _commandInterface = scene.getCommandInterface(_projectSignature);
         _commandInterface.setThemeTagDefProperty = setThemeTagDefProperty;
         _commandInterface.addAdditionalProperty = addAdditionalProperty;
      };

      var deepCopyObject = function (obj, objCopy) {
         Object.keys(obj).forEach(function (key) {
            switch (typeof obj[key]) {
               case "object":
                  objCopy[key] = deepCopyObject(obj[key], {});
                  break;
               case "string":
               case "number":
                  objCopy[key] = obj[key];
                  break;
            }
         });
         return objCopy;
      };

      var themeTagDefPropertyExists = function (themeTag, defProperty) {
         if (!scene.hasThemeTag(themeTag)) {
            throw new Error("ThemeableScene: Scene does not have a themeTag(" + themeTag + ").");
         }
         if (!scene.hasThemeTagDefProperty(themeTag, defProperty)) {
            throw new Error("ThemeableScene: Scene does not have a def property(" + defProperty + ") for themeTag(" + themeTag + ").");
         }
         return true;
      };

      var setThemeTagDefProperty = function (themeTag, defProperty, value) {
         if (themeTagDefPropertyExists(themeTag, defProperty)) {
            _themeablesLookup[themeTag].def[defProperty] = value;
            _eventDispatcher.trigger("themeTagDefPropertyChange", {
               themeTag: themeTag,
               defProperty: defProperty,
               value: value
            });
         }
      };

      var addAdditionalProperty = function (name, value) {
         _additionalProperties[name] = value;
      };

      buildCommandInterface();
      optimizeThemeablesLookup();

      // public properties
      Object.defineProperties(scene,
         {
            /**
             *  @public
             *  @readonly
             *  @memberof tscml.ThemeableScene
             *  @property {Array.<Object>} themeables - Themeable items for scene.
             */
            themeables: {
               configurable: true,
               get: function () {
                  return [].concat(_themeables);
               }
            }
         }
      );

      /**
       *  Get an object with access to a Content Scenes manipulation methods.  This is used internally within Media Lib.
       *  @memberof tscml.ThemeableScene
       *  @function getCommandInterface
       *  @param {Number} projectSignature - Project signature produced to control access.
       *  @return {Object}
       */
      scene.getCommandInterface = function (projectSignature) {
         if (_projectSignature !== projectSignature) {
            throw new Error("Tried to get command interface with invalid project signature");
         }
         return _commandInterface;
      };

      /**
       *  Add a callback function for an event.
       *  @memberof tscml.ThemeableScene
       *  @function on
       *  @param {String} eventName - Name of event to listen for.
       *  @param {Function} callback - Callback function for event.
       *  @listens tscml.ThemeableScene#themeTagDefPropertyChange
       *  @listens tscml.Scene#audioNarrationChange
       *  @listens tscml.Scene#audioNarrationRemoved
       */
      scene.on = _eventDispatcher.on;

      /**
       *  Remove a callback function for an event.
       *  @memberof tscml.ThemeableScene
       *  @function off
       *  @param {String} eventName - Name of event to listen for.
       *  @param {Function} callback - Callback function for event.
       */
      scene.off = _eventDispatcher.off;

      /**
       *  Will return the JSON for the Scene object
       *  @function toJSON
       *  @memberof tscml.ThemeableScene
       *  @return {Object}
       */
      scene.toJSON = function () {
         var json = {
            id: scene.id,
            type: scene.type,
            title: scene.title,
            duration: scene.duration,
            themeables: _themeables
         };

         if(scene.audioNarration !== null) {
            json.audioNarration = {
               id: scene.audioNarration.id,
               uri: scene.audioNarration.uri,
               mimeType: scene.audioNarration.mimeType
            };
         }

         if (_additionalProperties) {
            AdditionalPropertyHelper.updatePropertiesOnObject(_additionalProperties, json);
         }

         return json;
      };

      /**
       *  Get value for a theme tag def property.
       *  @function getThemeTagDefPropertyValue
       *  @param {String} themeTag - Theme tag.
       *  @param {String} defProperty - Theme tag def property.
       *  @memberof tscml.ThemeableScene
       *  @return {String|Number|Boolean}
       */

      scene.getThemeTagDefPropertyValue = function (themeTag, defProperty) {
         if (themeTagDefPropertyExists(themeTag, defProperty)) {
            return _themeablesLookup[themeTag].def[defProperty];
         }
      };

      /**
       *  Find out if scene has a specific theme tag.
       *  @function hasThemeTag
       *  @param {String} themeTag - Theme tag to validate.
       *  @memberof tscml.ThemeableScene
       *  @return {Boolean}
       */
      scene.hasThemeTag = function (themeTag) {
         return _themeablesLookup[themeTag] !== undefined;
      };

      /**
       *  Find out if scene has a specific def property for a theme tag.
       *  @function hasThemeTagDefProperty
       *  @param {String} themeTag - Theme tag to validate.
       *  @param {String} defProperty - Def property to validate.
       *  @memberof tscml.ThemeableScene
       *  @return {Boolean}
       */
      scene.hasThemeTagDefProperty = function (themeTag, defProperty) {
         return (scene.hasThemeTag(themeTag) && _themeablesLookup[themeTag].def !== undefined && _themeablesLookup[themeTag].def[defProperty] !== undefined);
      };

      /**
       * Internally used methods
       */
      scene.copyThemeables = function (projectSignature, themeables) {
         if (_projectSignature !== projectSignature) {
            throw new Error("Tried to copy themeable properties with invalid project signature");
         }
         _themeables = [];
         themeables.forEach(function (themeableElement) {
            _themeables.push(deepCopyObject(themeableElement, {}));
         });
      };

      scene.cloneSceneContent = function (sceneClone) {
         sceneClone.copyThemeables(_projectSignature, _themeables);
         return sceneClone;
      };

      return scene;
   };

   return {
      /**
       *  Factory method that returns a new ThemeableScene object.
       *  @function create
       *  @memberof tscml.ThemeableScene
       *  @param {tscml.Scene} scene - Scene instance to extend.
       *  @param {Object} params
       *  @param {Number} params.projectSignature - Project signature used to control access to command interface.
       *  @param {tscml.EventDispatcher} params.eventDispatcher - Event dispatcher instance.
       *  @param {Array.<Object>} params.themeables - Object of themeable items.
       *  @static
       *  @return new ThemeableScene instance
       */
      create: function (scene, params) {
         return new ThemeableScene(scene, params);
      },
      /**
       *  Method will destroy property and methods decorated by Themeable scene on passed scene object.
       *  @function destroy
       *  @memberof tscml.ThemeableScene
       *  @static
       *  @param {tscml.Scene} scene - Scene instance to destroy.
       */
      destroy: function(scene) {
         delete scene.themeables;
         scene.getCommandInterface = undefined;
         scene.on = undefined;
         scene.off = undefined;
         scene.toJSON = undefined;
         scene.getThemeTagDefPropertyValue = undefined;
         scene.hasThemeTag = undefined;
         scene.hasThemeTagDefProperty = undefined;
         scene.copyThemeables = undefined;
         scene.cloneSceneContent = undefined;
      }
   };
});

(function (root, themeablesDictionaryFactory) {
   "use strict";

   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.themeablesDictionary = themeablesDictionaryFactory(root, namespace.sceneType);

})(this, function (root, sceneType) {

   "use strict";

   /**
    * @memberof tscml
    * @class themeablesDictionary
    * @params {String} type - Type of Scene.
    * @classdesc Dictionary for getting default themeables array by scene type.
    */
   var themeablesDictionary = function (type) {
      var themeables;

      switch (type) {
         case sceneType.TITLE:
            themeables = [
               {
                  "themeTag": "titleBackground"
               },
               {
                  "themeTag": "titleTitle",
                  "def": {
                     "text": ""
                  }
               },
               {
                  "themeTag": "titleSubtitle",
                  "def": {
                     "text": ""
                  }
               }
            ];
            break;
         case sceneType.INTRO:
            themeables = [
               {
                  "themeTag": "introBackground"
               },
               {
                  "themeTag": "introTitle",
                  "def": {
                     "text": ""
                  }
               },
               {
                  "themeTag": "introSubtitle",
                  "def": {
                     "text": ""
                  }
               }
            ];
            break;
         case sceneType.OUTRO:
            themeables = [
               {
                  "themeTag": "outroBackground"
               },
               {
                  "themeTag": "outroTitle",
                  "def": {
                     "text": ""
                  }
               },
               {
                  "themeTag": "outroSubtitle",
                  "def": {
                     "text": ""
                  }
               }
            ];
            break;
         default:
            break;
      }

      return themeables;
   };
   return {
      /**
       *  Get default themeables array by scene type.
       *  @function getThemeables
       *  @memberof tscml.themeablesDictionary
       *  @params {String} type - Type of Scene.
       *  @static
       *  @return {Array.<Object>|undefined} List of themeable objects for scene type.
       */
      getThemeables: function (type) {
         return themeablesDictionary(type);
      }
   };
});


(function (root, sceneFactory) {
   "use strict";

   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.Scene = sceneFactory(root, namespace.idGenerator, namespace.sceneType, namespace.defaultSceneValues, namespace.EmptyScene, namespace.ContentScene, namespace.ThemeableScene);

})(this, function (root, idGenerator, sceneType, defaultSceneValues, EmptyScene, ContentScene, ThemeableScene) {

   "use strict";

   /**
    * Scene type has been changed
    * @event tscml.Scene#sceneTypeChange
    * @type {object}
    * @property {String} type - Event name
    * @property {tscml.Scene} scene - Scene object with type change.
    */

   /**
    * Audio narration has been changed
    * @event tscml.Scene#audioNarrationChange
    * @type {object}
    * @property {String} type - Event name
    * @property {tscml.Scene} scene - Scene object with audio narration change.
    */

   /**
    * Audio narration has been removed.
    * @event tscml.Scene#audioNarrationRemoved
    * @type {object}
    * @property {String} type - Event name
    * @property {tscml.Scene} scene - Scene object with audio narration change.
    */

   /**
    * @memberof tscml
    * @class Scene
    * @classdesc Base object for an individual Scene on the scene track.
    * @param {Object} params
    * @param {String} [params.id] - id for existing scene.
    * @param {String} [params.type="content"] - Scene type.
    * @param {String} [params.title=""] - title for scene.
    * @param {Number} [params.duration=0] - duration for scene.
    * @param {tscml.SceneTrack} params.sceneTrack - Scene track reference.
    * @param {Number} params.projectSignature - Project signature used to control access to command interface.
    * @param {Function} params.eventDispatcherFactory - Factory method to get new event dispatcher.
    */
   var Scene = function (params) {
      var _id,
         _type,
         _title,
         _duration,
         _sceneTrack,
         _audioNarration,
         _projectSignature,
         _commandInterface,
         _eventDispatcher,
         _public;

      _id = idGenerator.registerObject(params.id);
      _type = params.type !== undefined ? params.type : defaultSceneValues.TYPE;
      _title = params.title !== undefined ? params.title : defaultSceneValues.TITLE;
      _duration = params.duration !== undefined ? params.duration : 0;
      _sceneTrack = params.sceneTrack;
      _audioNarration = null;
      _projectSignature = params.projectSignature;
      _eventDispatcher = params.eventDispatcherFactory();
      _public = {};

      var decorateSceneByType = function(type) {
         switch (type) {
            case sceneType.EMPTY:
               return EmptyScene.create(_public, params);
            case sceneType.CONTENT:
               return ContentScene.create(_public, params);
            case sceneType.INTRO:
            case sceneType.TITLE:
            case sceneType.OUTRO:
               return ThemeableScene.create(_public, params);
            default:
               throw new Error("decorateSceneByType - Scene type(" + type + ") is not supported.");
         }
      };

      var unDecorateSceneByType = function(type) {
         switch (type) {
            case sceneType.EMPTY:
               EmptyScene.destroy(_public);
               break;
            case sceneType.CONTENT:
               ContentScene.destroy(_public);
               break;
            case sceneType.INTRO:
            case sceneType.TITLE:
            case sceneType.OUTRO:
               ThemeableScene.destroy(_public);
               break;
            default:
               throw new Error("unDecorateSceneByType - Scene type(" + type + ") is not supported.");
         }
         _public.getCommandInterface = getCommandInterface;
      };

      var getCommandInterface = function(projectSignature) {
         if (_projectSignature !== projectSignature) {
            throw new Error("Tried to get command interface with invalid project signature");
         }
         return _commandInterface;
      };

      var setTitle = function(title) {
         _title = title || "";
      };

      var setType = function(type, additionalParams) {
         unDecorateSceneByType(_type);
         _type = type;
         params.themeables = additionalParams.themeables;
         decorateSceneByType(_type);
         _eventDispatcher.trigger("sceneTypeChange", {scene: _public});
      };

      var setDuration = function(duration) {
         if(typeof duration !== 'number') {
            throw(new Error('Scene duration is expecting a number, but got (' + duration + ')'));
         }
         _duration = duration;
      };

      var setAudioNarration = function(narrationParams) {
         _audioNarration = Object.defineProperties({}, {
            id: {
               value: idGenerator.registerObject(narrationParams.id)
            },
            uri: {
               value: narrationParams.uri
            },
            mimeType: {
               value: narrationParams.mimeType
            }
         });
         _eventDispatcher.trigger("audioNarrationChange", {scene: _public});
      };

      var removeAudioNarration = function() {
         _audioNarration = null;
         _eventDispatcher.trigger("audioNarrationRemoved", {scene: _public});
      };

      _commandInterface = {
         setTitle: setTitle,
         setType: setType,
         setDuration: setDuration,
         setAudioNarration: setAudioNarration,
         removeAudioNarration: removeAudioNarration
      };

      // public properties
      _public = Object.defineProperties(_public,
         {
            /**
             *  @public
             *  @readonly
             *  @memberof tscml.Scene
             *  @property {String} id - Unique id for this object.
             */
            id: {
               value: _id
            },
            /**
             *  @public
             *  @readonly
             *  @memberof tscml.Scene
             *  @property {String} type - Type of Scene.
             */
            type: {
               get: function() {
                  return _type;
               }
            },
            /**
             *  @public
             *  @readonly
             *  @memberof tscml.Scene
             *  @property {String} title - Title of the Scene.
             */
            title: {
               get: function () {
                  return _title;
               }
            },
            /**
             *  @public
             *  @readonly
             *  @memberof tscml.Scene
             *  @property {Number} duration - The duration of the scene.
             */
            duration: {
               get: function() {
                  return _duration;
               }
            },
            /**
             *  @public
             *  @readonly
             *  @memberof tscml.Scene
             *  @property {tscml.sceneTrack} sceneTrack - Unique id for this object.
             */
            sceneTrack: {
               value: _sceneTrack
            },
            /**
             *  @public
             *  @readonly
             *  @memberof tscml.Scene
             *  @property {Object} [audioNarration=null] - Unique id for this object.
             *  @param {String} audioNarration.id - id for audio narration file.
             *  @param {String} audioNarration.uri - Uri for audio narration file.
             *  @param {String} audioNarration.mimeType - Mime type for audio narration file.
             */
            audioNarration: {
               get: function() {
                  return _audioNarration;
               }
            }
         }
      );

      /**
       *  Get an object with access to a Scenes manipulation methods.  This is used internally within Media Lib.
       *  @memberof tscml.Scene
       *  @function getCommandInterface
       *  @param {Number} projectSignature - Project signature produced to control access.
       *  @return {Object}
       */
      _public.getCommandInterface = getCommandInterface;

      /**
       *  Check if scene is themeable.
       *  @memberof tscml.Scene
       *  @function isThemeable
       *  @return {Boolean} is the scene themeable.
       */
      _public.isThemeable = function () {
         return _public.themeables !== undefined;
      };

      /**
       *  Will return a new copy of the Scene instance with a unique id.
       *  @function clone
       *  @memberof tscml.Scene
       *  @return {tscml.Scene} Copy of the Scene
       */
      _public.clone = function () {
         var sceneParams = {
            title: _title,
            type: _type,
            sceneTrack: _sceneTrack,
            projectSignature: _projectSignature,
            eventDispatcherFactory: params.eventDispatcherFactory
         };
         var sceneClone = new Scene(sceneParams);
         return _public.cloneSceneContent(sceneClone);
      };

      params.eventDispatcher = _eventDispatcher;

      return decorateSceneByType(_type);
   };

   return {
      /**
       *  Factory method that returns a new Scene object.
       *  @function create
       *  @memberof tscml.Scene
       *  @param {Object} params
       *  @param {String} [params.id] - id for existing scene.
       *  @param {String} [params.type="content"] - Scene type.
       *  @param {String} [params.title=""] - title for scene.
       *  @param {Number} [params.duration=0] - duration for scene.
       *  @param {tscml.SceneTrack} params.sceneTrack - Scene track reference.
       *  @param {Number} params.projectSignature - Project signature used to control access to command interface.
       *  @param {Function} params.eventDispatcherFactory - Factory method to get new event dispatcher.
       *  @static
       *  @return {tscml.Scene} new Scene instance
       */
      create: function (params) {
         return new Scene(params);
      }
   };
});

(function (root, sceneTrackFactory) {
   "use strict";

   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.SceneTrack = sceneTrackFactory(root, namespace.AdditionalPropertyHelper);

})(this, function (root, AdditionalPropertyHelper) {

   "use strict";

   /**
    * Scene added event fires when a scene is added to the scene track.
    * @event tscml.SceneTrack#sceneAdded
    * @type {object}
    * @property {String} type - Event name
    * @property {Number} index - index that scene was added.
    * @property {tscml.Scene} scene - Scene that was added.
    */

   /**
    * Scene removed event fires when a scene was removed from the scene track.
    * @event tscml.SceneTrack#sceneRemoved
    * @type {object}
    * @property {String} type - Event name
    * @property {Number} index - index that scene was removed from.
    * @property {tscml.Scene} scene - Scene that was removed.
    */

   /**
    * Scene moved event fires when a scene is moved to a new index on the scene track.
    * @event tscml.SceneTrack#sceneMoved
    * @type {object}
    * @property {String} type - Event name
    * @property {Number} fromIndex - index that scene was moved from.
    * @property {Number} toIndex - index that scene was moved to.
    * @property {tscml.Scene} scene - Scene that was removed.
    */

   /**
    * @memberof tscml
    * @class SceneTrack
    * @classdesc A track that can contain a series of Scenes in a particular order.
    * @param {Object} params
    * @param {tscml.Timeline} [params.timeline] - Timeline instance reference.
    * @param {Number} [params.projectSignature] - Project signature used to control access to command interface.
    * @param {Function} [params.eventDispatcherFactory] - Factory method to get new event dispatcher.
    * @fires tscml.SceneTrack#sceneAdded
    * @fires tscml.SceneTrack#sceneRemoved
    * @fires tscml.SceneTrack#sceneMoved
    */
   var SceneTrack = function (params) {
      var _projectSignature,
         _scenes,
         _timeline,
         _additionalProperties,
         _eventDispatcher,
         _public;

      _projectSignature = params.projectSignature;
      _scenes = [];
      _timeline = params.timeline;
      _additionalProperties = {};
      _eventDispatcher = params.eventDispatcherFactory();

      var indexIsOutOfRangeOfScenes = function (index) {
         return (index < 0 || index >= _scenes.length);
      };

      var appendScene = function (scene) {
         _scenes.push(scene);
         _eventDispatcher.trigger("sceneAdded", {scene: scene, index: _scenes.length - 1});
      };

      var insertSceneAtIndex = function (scene, index) {
         if (indexIsOutOfRangeOfScenes(index) && _scenes.length !== index) {
            throw(new Error("SceneTrack.insertSceneAtIndex(): index=" + index + " is out of range."));
         }
         _scenes.splice(index, 0, scene);
         _eventDispatcher.trigger("sceneAdded", {scene: scene, index: index});
      };

      var removeSceneAtIndex = function (index) {
         if (indexIsOutOfRangeOfScenes(index)) {
            throw(new Error("SceneTrack.removeSceneAtIndex(): index=" + index + " is out of range."));
         }
         var removedScene = _scenes.splice(index, 1)[0];
         _eventDispatcher.trigger("sceneRemoved", {scene: removedScene, index: index});
         return removedScene;
      };

      var removeScene = function (scene) {
         for (var i = 0, numScenes = _scenes.length; i < numScenes; i++) {
            if (_scenes[i].id === scene.id) {
               var removedScene = _scenes.splice(i, 1)[0];
               _eventDispatcher.trigger("sceneRemoved", {scene: removedScene, index: i});
               return removedScene;
            }
         }
      };

      var moveSceneAtIndex = function (fromIndex, toIndex) {
         if (indexIsOutOfRangeOfScenes(fromIndex)) {
            throw(new Error("SceneTrack.moveSceneAtIndex(): fromIndex=" + fromIndex + " is out of range."));
         } else if (indexIsOutOfRangeOfScenes(toIndex)) {
            throw(new Error("SceneTrack.moveSceneAtIndex(): toIndex=" + toIndex + " is out of range."));
         }
         _scenes.splice(toIndex, 0, _scenes.splice(fromIndex, 1)[0]);
         _eventDispatcher.trigger("sceneMoved", {scene: _scenes[toIndex], fromIndex: fromIndex, toIndex: toIndex});
      };

      var addAdditionalProperty = function (name, value) {
         _additionalProperties[name] = value;
      };

      _public = Object.defineProperties({}, {
            /**
             *  @public
             *  @readonly
             *  @memberof tscml.SceneTrack
             *  @property {Object} timeline - Reference to the timeline.
             */
            timeline: {
               value: _timeline
            },
            /**
             *  @public
             *  @readonly
             *  @memberof tscml.SceneTrack
             *  @property {Number} duration - Duration of the entire track.
             */
            duration: {
               get: function () {
                  return (_scenes.length === 0) ? 0 : _scenes.reduce(function (previousValue, currentScene, index, scenes) {
                     return previousValue + currentScene.duration;
                  }, 0);
               }
            },
            /**
             *  @public
             *  @readonly
             *  @memberof tscml.SceneTrack
             *  @property {Number} numberScenes - The number of Scenes in the track.
             */
            numberScenes: {
               get: function () {
                  return (_scenes && _scenes.length ) || 0;
               }
            },
            /**
             *  @public
             *  @readonly
             *  @memberof tscml.SceneTrack
             *  @property {Array.<tscml.Scene>} scenes - Copy of the scenes in the track.
             */
            scenes: {
               get: function () {
                  return [].concat(_scenes);
               }
            }
         }
      );

      /**
       *  Get an object with access to a SceneTrack manipulation methods.  This is used internally within Media Lib.
       *  @memberof tscml.SceneTrack
       *  @function getCommandInterface
       *  @param {Number} projectSignature - Project signature produced to control access.
       *  @return {Object}
       */
      _public.getCommandInterface = function (projectSignature) {
         if (_projectSignature !== projectSignature) {
            throw new Error("Tried to get command interface with invalid project signature");
         }
         return {
            appendScene: appendScene,
            insertSceneAtIndex: insertSceneAtIndex,
            removeSceneAtIndex: removeSceneAtIndex,
            removeScene: removeScene,
            moveSceneAtIndex: moveSceneAtIndex,
            addAdditionalProperty: addAdditionalProperty
         };
      };

      /**
       *  Add a callback function for an event.
       *  @memberof tscml.SceneTrack
       *  @function on
       *  @param {String} eventName - Name of event to listen for.
       *  @param {Function} callback - Callback function for event.
       *  @listens tscml.SceneTrack#sceneAdded
       *  @listens tscml.SceneTrack#sceneRemoved
       *  @listens tscml.SceneTrack#sceneMoved
       *  @example
       *  var onSceneAdded = function() {};
       *  var onSceneRemoved = function() {};
       *  var onSceneMoved = function() {};
       *  project.timeline.sceneTrack.on('sceneAdded', onSceneAdded);
       *  project.timeline.sceneTrack.on('sceneRemoved', onSceneRemoved);
       *  project.timeline.sceneTrack.on('sceneMoved', onSceneMoved);
       */
      _public.on = _eventDispatcher.on;

      /**
       *  Remove a callback function for an event.
       *  @memberof tscml.SceneTrack
       *  @function off
       *  @param {String} eventName - Name of event to listen for.
       *  @param {Function} callback - Callback function for event.
       *  @example
       *  var onSceneAdded = function() {};
       *  var onSceneRemoved = function() {};
       *  var onSceneMoved = function() {};
       *  project.timeline.sceneTrack.off('sceneAdded', onSceneAdded);
       *  project.timeline.sceneTrack.off('sceneRemoved', onSceneRemoved);
       *  project.timeline.sceneTrack.off('sceneMoved', onSceneMoved);
       */
      _public.off = _eventDispatcher.off;

      /**
       *  Will return the JSON for the SceneTrack object
       *  @function toJSON
       *  @memberof tscml.SceneTrack
       *  @return {Object}
       */
      _public.toJSON = function () {
         var json = {
            scenes: _scenes.map(function (scene) {
               return scene.toJSON();
            })
         };

         if (_additionalProperties) {
            AdditionalPropertyHelper.updatePropertiesOnObject(_additionalProperties, json);
         }

         return json;
      };

      return _public;
   };

   return {
      /**
       *  Factory method that returns a new SceneTrack object.
       *  @function create
       *  @memberof tscml.SceneTrack
       *  @param {Object} params
       *  @param {tscml.Timeline} [params.timeline] - Timeline instance reference.
       *  @param {Number} [params.projectSignature] - Project signature used to control access to command interface.
       *  @param {Function} [params.eventDispatcherFactory] - Factory method to get new event dispatcher.
       *  @static
       *  @return {tscml.SceneTrack} new SceneTrack instance
       */
      create: function (params) {
         return new SceneTrack(params);
      }
   };

});

(function (root, timelineFactory) {
   "use strict";

   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.Timeline = timelineFactory(root, namespace.SceneTrack, namespace.AdditionalPropertyHelper);

})(this, function (root, SceneTrack, AdditionalPropertyHelper) {

   "use strict";

   /**
    * @memberof tscml
    * @class Timeline
    * @classdesc Timeline is the top-level container for all tracks.
    * @param {Object} params
    * @param {tscml.Project} [params.project] - Project reference.
    * @param {Number} [params.projectSignature] - Project signature used to control access to command interface.
    * @param {Function} [params.eventDispatcherFactory] - Factory method to get new event dispatcher.
    */
   var Timeline = function (params) {

      var _project,
         _projectSignature,
         _sceneTrack,
         _additionalProperties,
         _eventDispatcher,
         _public;

      _project = params.project;
      _additionalProperties = {};
      _projectSignature = params.projectSignature;
      _eventDispatcher = params.eventDispatcherFactory();

      var addSceneTrack = function (sceneTrack) {
         if (_sceneTrack) {
            throw new Error("Timeline can only contain one Scene Track.");
         }
         if (sceneTrack) {
            _sceneTrack = sceneTrack;
         } else {
            var sceneTrackParams = {
               timeline: _public,
               projectSignature: _projectSignature,
               eventDispatcherFactory: params.eventDispatcherFactory
            };
            _sceneTrack = SceneTrack.create(sceneTrackParams);
         }
      };

      var addAdditionalProperty = function (name, value) {
         _additionalProperties[name] = value;
      };

      // public properties
      _public = Object.defineProperties({},
         {
            /**
             *  @public
             *  @readonly
             *  @memberof tscml.Timeline
             *  @property {tscml.Project} project - Project reference for the Timeline.
             */
            project: {
               value: _project
            },
            /**
             *  @public
             *  @readonly
             *  @memberof tscml.Timeline
             *  @property {tscml.SceneTrack} sceneTrack - SceneTrack instance for the timeline.
             */
            sceneTrack: {
               get: function () {
                  return _sceneTrack;
               }
            }
         }
      );

      /**
       *  Get an object with access to a Timeline manipulation methods.  This is used internally within Media Lib.
       *  @memberof tscml.Timeline
       *  @function getCommandInterface
       *  @param {Number} projectSignature - Project signature produced to control access.
       *  @return {Object}
       */
      _public.getCommandInterface = function (projectSignature) {
         if (_projectSignature !== projectSignature) {
            throw new Error("Tried to get command interface with invalid project signature");
         }
         return {
            addSceneTrack: addSceneTrack,
            addAdditionalProperty: addAdditionalProperty
         };
      };

      /**
       *  Add a callback function for an event.  Dispatches events: (none)
       *  @memberof tscml.Timeline
       *  @function on
       *  @param {String} eventName - Name of event to listen for.
       *  @param {Function} callback - Callback function for event.
       */
      _public.on = _eventDispatcher.on;

      /**
       *  Remove a callback function for an event.  Dispatches events: (none)
       *  @memberof tscml.Timeline
       *  @function off
       *  @param {String} eventName - Name of event to listen for.
       *  @param {Function} callback - Callback function for event.
       */
      _public.off = _eventDispatcher.off;

      /**
       *  Will return the JSON for the Timeline object
       *  @function toJSON
       *  @memberof tscml.Timeline
       *  @return {Object}
       */
      _public.toJSON = function () {
         var json = {
            sceneTrack: (_sceneTrack ? _sceneTrack.toJSON() : {})
         };

         if (_additionalProperties) {
            AdditionalPropertyHelper.updatePropertiesOnObject(_additionalProperties, json);
         }

         return json;
      };

      return _public;

   };

   return {
      /**
       *  Factory method that returns a new Timeline object.
       *  @function create
       *  @memberof tscml.Timeline
       *  @param {Object} params
       *  @param {tscml.Project} [params.project] - Project reference.
       *  @param {Number} [params.projectSignature] - Project signature used to control access to command interface.
       *  @param {Function} [params.eventDispatcherFactory] - Factory method to get new event dispatcher.
       *  @static
       *  @return {tscml.Timeline} new Timeline instance
       */
      create: function (params) {
         return new Timeline(params);
      }
   };

});

(function (root, commandNamesFactory) {
   "use strict";

   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.commandNames = commandNamesFactory(root);

})(this, function (root) {

   "use strict";

   /**
    * @memberof tscml
    * @class commandNames
    */
   var commandNames = function () {
      return Object.defineProperties({}, {
         /**
          * @constant
          * @type {string}
          * @memberof tscml.commandNames
          */
         INSERT_SCENE: {
            value: "insertScene"
         },
         /**
          * @constant
          * @type {string}
          * @memberof tscml.commandNames
          */
         INSERT_TITLE_CARD_SCENE_WITH_TITLES: {
            value: "insertTitleCardSceneWithTitles"
         },
         /**
          * @constant
          * @type {string}
          * @memberof tscml.commandNames
          */
         ADD_SCENE_WITH_SOURCE: {
            value: "addSceneWithSource"
         },
         /**
          * @constant
          * @type {string}
          * @memberof tscml.commandNames
          */
         APPEND_SCENE: {
            value: "appendScene"
         },
         /**
          * @constant
          * @type {string}
          * @memberof tscml.commandNames
          */
         MOVE_SCENE: {
            value: "moveScene"
         },
         /**
          * @constant
          * @type {string}
          * @memberof tscml.commandNames
          */
         REMOVE_SCENE: {
            value: "removeScene"
         },
         /**
          * @constant
          * @type {string}
          * @memberof tscml.commandNames
          */
         ADD_SCENE_SOURCE: {
            value: "addSceneSource"
         },
         /**
          * @constant
          * @type {string}
          * @memberof tscml.commandNames
          */
         REMOVE_SCENE_SOURCE: {
            value: "removeSceneSource"
         },
         /**
          * @constant
          * @type {string}
          * @memberof tscml.commandNames
          */
         SET_PROJECT_METADATA: {
            value: "setProjectMetadata"
         },
         /**
          * @constant
          * @type {string}
          * @memberof tscml.commandNames
          */
         SET_SCENE_TITLE: {
            value: "setSceneTitle"
         },
         /**
          * @constant
          * @type {string}
          * @memberof tscml.commandNames
          */
         SET_SCENE_DURATION: {
            value: "setSceneDuration"
         },
         /**
          * @constant
          * @type {string}
          * @memberof tscml.commandNames
          */
         SET_SCENE_AUDIO_NARRATION_WITH_DURATION: {
            value: "setSceneAudioNarrationWithDuration"
         },
         /**
          * @constant
          * @type {string}
          * @memberof tscml.commandNames
          */
         SET_SCENE_AUDIO_NARRATION: {
            value: "setSceneAudioNarration"
         },
         /**
          * @constant
          * @type {string}
          * @memberof tscml.commandNames
          */
         REMOVE_SCENE_AUDIO_NARRATION: {
            value: "removeSceneAudioNarration"
         },
         /**
          * @constant
          * @type {string}
          * @memberof tscml.commandNames
          */
         SET_THEMEABLE_DEF_PROPERTY: {
            value: "setThemeableProperty"
         },
         /**
          * @constant
          * @type {string}
          * @memberof tscml.commandNames
          */
         SET_THEME_FILE: {
            value: "setThemeFile"
         },
         /**
          * @constant
          * @type {string}
          * @memberof tscml.commandNames
          */
         SET_SCENE_TYPE: {
            value: "setSceneType"
         },
         /**
          * @constant
          * @type {string}
          * @memberof tscml.commandNames
          */
         SET_SOURCE_MIME_TYPE: {
            value: "setSourceMimeType"
         }
      });
   };

   return commandNames();

});

(function (root, commandHistoryFactory) {
   "use strict";

   var Q = (typeof exports !== 'undefined') ? require("q") : root.Q;
   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.CommandHistory = commandHistoryFactory(root, Q);

})(this, function (root, Q) {

   "use strict";

   /**
    * @memberof tscml
    * @class CommandHistory
    * @param {Number} projectSignature - Project signature used to control access to command interface.
    * @param {Array} statLoaders - List of stat loaders.
    * @param {EventNotificationBundler} eventNotificationBundler - Event notification bundler.
    * @classdesc History of commands.
    */
   var CommandHistory = function (projectSignature, statLoaders, eventNotificationBundler) {
      var _redoableCommands,
         _undoableCommands,
         _commandHelper,
         _executeQueue,
         _public;

      _redoableCommands = [];
      _undoableCommands = [];

      _commandHelper = {
         getProjectSignature: function () {
            return projectSignature;
         },
         getCommandInterface: function (obj) {
            return obj.getCommandInterface(projectSignature);
         },
         getStatLoaders: function () {
            return statLoaders;
         },
         getEventDispatcherFactory: function () {
            return eventNotificationBundler.eventDispatcherFactory;
         }
      };

      _executeQueue = Q();
      _public = {};

      /**
       *  Will execute a command, if command is successful it will also be stored in history.
       *  @function execute
       *  @param {Object} command - Command object.
       *  @memberof tscml.CommandHistory
       *  @return {Object} Q Promise that resolves with the result of the command.
       */
      _public.execute = function (command) {
         var defer = Q.defer();

         // _executeQueue will wait until a command is executed to run another command.
         _executeQueue.finally(function () {
            eventNotificationBundler.startBundling();
            command.execute(_commandHelper).then(
               function (result) {
                  _undoableCommands.push(command);
                  eventNotificationBundler.flushEvents();
                  defer.resolve(result);
               }
            ).catch(
               function (error) {
                  command.unExecute(_commandHelper).finally(function () {
                     eventNotificationBundler.reset();
                     defer.reject(error);
                  });
               }
            );
         });

         _executeQueue = defer.promise;

         return defer.promise;
      };

      /**
       *  Will undo the last command.
       *  @function undo
       *  @memberof tscml.CommandHistory
       *  @return {Object} Q Promise that resolves when the command has been sucessfully undone.
       */
      _public.undo = function () {
         var defer = Q.defer();

         if (_undoableCommands.length > 0) {
            eventNotificationBundler.startBundling();
            _undoableCommands[_undoableCommands.length - 1].unExecute(_commandHelper).then(function (result) {
               _redoableCommands.push(_undoableCommands.pop());
               eventNotificationBundler.flushEvents();
               defer.resolve(result);
            }).catch(function (error) {
               eventNotificationBundler.reset();
               defer.reject(error);
            });
         } else {
            defer.resolve();
         }

         return defer.promise;
      };

      /**
       *  Will redo the last command.
       *  @function redo
       *  @memberof tscml.CommandHistory
       *  @return {Object} Q Promise that resolves with the result of executing the command.
       */
      _public.redo = function () {
         var defer = Q.defer();

         if (_redoableCommands.length > 0) {
            eventNotificationBundler.startBundling();
            _redoableCommands[_redoableCommands.length - 1].execute(_commandHelper).then(function (result) {
               _undoableCommands.push(_redoableCommands.pop());
               eventNotificationBundler.flushEvents();
               defer.resolve(result);
            }).catch(function (error) {
               eventNotificationBundler.reset();
               defer.reject(error);
            });
         } else {
            defer.resolve();
         }

         return defer.promise;
      };

      return _public;
   };

   return CommandHistory;

});

(function (root, multiCommandFactory) {
   "use strict";

   var Q = (typeof exports !== 'undefined') ? require("q") : root.Q;
   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.MultiCommand = multiCommandFactory(root, Q);

})(this, function (root, Q) {

   "use strict";

   /**
    * @memberof tscml
    * @class MultiCommand
    * @param {String} commandName - Name of the derived command
    * @classdesc Base class implementing functionality for executing multiple commands atomically
    * @example
    * // Create multi-commands by deriving from MultiCommand
    * var DerivedCommand = function(){
     *   // Your derived class _must_ implement handleExecute and return a promise
     *   this.handleExecute = function(commandHelper, multiCommandHelper){
     *     var firstCommand = new CommandTypeOne(cmdOneArg);
     *     return multiCommandHelper.executeCommand(firstCommand)
     *     .then( function(firstResult){
     *       var secondCommand = new CommandTypeTwo(firstResult); // executeCommand resolves with command result
     *       return multiCommandHelper.executeCommand(secondCommand);
     *     }
     *   }
     *
     *   // Always return the result of calling the MultiCommand constructor from your derived constructor
     *   return MultiCommand.call(this, "DerivedCommand")
     * }
    * var myCommand = new DerivedCommand();
    */
   var MultiCommand = function (commandName) {
      var _commandName,
         _executedCommands,
         _handleExecute,
         _public;

      _commandName = commandName;
      _executedCommands = [];
      _handleExecute = this.handleExecute;

      _public = Object.defineProperties({}, {
         commandName: {
            value: _commandName
         }
      });

      if (root.tscml.env === "TEST") {
         _public.handleExecute = _handleExecute;
      }

      var generateSubExecutor = function (commandHelper) {
         return function (command) {
            return command.execute(commandHelper).then(function (result) {
               _executedCommands.push(command);
               return result;
            });
         };
      };

      /**
       *  Execute multi-command
       *  @function execute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to execute.
       *  @memberof tscml.MultiCommand
       *  @return {Object} Q Promise resolving with the result of the command (returned by `handleExecute` in derived class)
       */
      _public.execute = function (commandHelper) {
         if (typeof _handleExecute != 'function') {
            return Q.reject('MultiCommand derived with no handleExecute method.');
         }

         var multiCommandHelper = {
            executeCommand: generateSubExecutor(commandHelper)
         };

         var abort = function (error) {
            return _public.unExecute(commandHelper).finally(function () {
               return Q.reject(error);
            });
         };

         try {
            return _handleExecute(commandHelper, multiCommandHelper).catch(abort);
         } catch (error) {
            return abort(error);
         }
      };

      /**
       *  Un-execute the multi-command
       *  @function unExecute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to un-execute.
       *  @memberof tscml.MultiCommand
       *  @return {Object} Q Promise that resolves when the command has been successfully undone
       */
      _public.unExecute = function (commandHelper) {
         if (_executedCommands.length === 0) {
            return Q();
         }

         try {
            var defer = Q.defer();
            defer.resolve();
            var promise = defer.promise;
            var chain = function (p, cmd) {
               return p.then(function () {
                  return cmd.unExecute(commandHelper);
               });
            };
            for (var i = _executedCommands.length - 1; i >= 0; --i) {
               promise = chain(promise, _executedCommands[i]);
            }
            return promise;
         } catch (error) {
            return Q.reject(error);
         }
      };

      return _public;
   };

   return MultiCommand;
});

(function (root, insertSceneCommandFactory) {
   "use strict";

   var Q = (typeof exports !== 'undefined') ? require("q") : root.Q;
   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.InsertSceneCommand = insertSceneCommandFactory(root, Q, namespace.commandNames, namespace.defaultSceneValues, namespace.themeablesDictionary, namespace.sceneType, namespace.Scene);

})(this, function (root, Q, commandNames, defaultSceneValues, themeablesDictionary, sceneType, Scene) {

   "use strict";

   /**
    * @memberof tscml
    * @class InsertSceneCommand
    * @param {tscml.SceneTrack} sceneTrack - Reference to the SceneTrack to execute command on.
    * @param {Number} index - The index to insert new Scene at.
    * @param {Object} [options] - Information about the scene to be added.
    * @param {String} [options.id] - Id to use with Scene.
    * @param {String} [options.title=""] - Title of the scene.
    * @param {String} [options.type="content"] - Scene type
    * @param {Number} [options.duration=0] - Duration of scene.
    * @classdesc Inserts a Scene at a specific index in a SceneTrack.
    */
   var InsertSceneCommand = function (sceneTrack, index, options) {
      var _commandName,
         _addedScene,
         _public;

      _commandName = commandNames.INSERT_SCENE;

      _public = Object.defineProperties({}, {
         commandName: {
            value: _commandName
         }
      });

      /**
       *  Execute the insert scene command
       *  @function execute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to execute.
       *  @memberof tscml.InsertSceneCommand
       *  @return {Object} Q Promise that resolves with the inserted Scene.
       */
      _public.execute = function (commandHelper) {
         var defer = Q.defer();

         try {
            var sceneTrackCommandInterface = commandHelper.getCommandInterface(sceneTrack);
            var projectSignature = commandHelper.getProjectSignature();
            var eventDispatcherFactory = commandHelper.getEventDispatcherFactory();
            var sceneParams = {
               title: options.title,
               type: options.type,
               duration: options.duration,
               sceneTrack: sceneTrack,
               projectSignature: projectSignature,
               eventDispatcherFactory: eventDispatcherFactory
            };

            if (options.id) {
               sceneParams.id = options.id;
            }

            var themeables = options.themeables ? options.themeables : themeablesDictionary.getThemeables(options.type);
            if (themeables) {
               sceneParams.themeables = themeables;
            }

            var addedScene = Scene.create(sceneParams);
            sceneTrackCommandInterface.insertSceneAtIndex(addedScene, index);
            _addedScene = addedScene;
            defer.resolve(addedScene);
         } catch (error) {
            defer.reject(error);
         }

         return defer.promise;
      };

      /**
       *  Un-execute the insert scene command
       *  @function unExecute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to un-execute.
       *  @memberof tscml.InsertSceneCommand
       *  @return {Object} Q Promise that resolves when the command has been successfully undone.
       */
      _public.unExecute = function (commandHelper) {
         var defer = Q.defer();
         if (_addedScene) {
            try {
               var sceneTrackCommandInterface = commandHelper.getCommandInterface(sceneTrack);
               sceneTrackCommandInterface.removeScene(_addedScene);
               defer.resolve();
            } catch (error) {
               defer.reject(error);
            }
         } else {
            defer.resolve();
         }
         return defer.promise;
      };

      return _public;
   };

   return {
      /**
       *  Factory method that returns a new InsertSceneCommand object.
       *  @function create
       *  @memberof tscml.InsertSceneCommand
       *  @param {tscml.SceneTrack} sceneTrack - Reference to the SceneTrack to execute command on.
       *  @param {Number} index - The index to insert new Scene at.
       *  @param {Object} options - Optional information about the scene to be added.
       *  @param {String} [options.id] - Id to use with Scene.
       *  @param {String} [options.title=""] - Title of the scene.
       *  @param {String} [options.type="content"] - Scene type
       *  @param {Number} [options.duration=0] - Duration of scene.
       *  @static
       *  @return {tscml.InsertSceneCommand} new InsertSceneCommand instance
       */
      create: function (sceneTrack, index, options) {
         options = options || {};
         options.title = options.title !== undefined ? options.title : defaultSceneValues.TITLE;
         options.type = options.type !== undefined ? options.type : defaultSceneValues.TYPE;
         options.duration = options.duration !== undefined ? options.duration : defaultSceneValues.DURATION;
         return new InsertSceneCommand(sceneTrack, index, options);
      }
   };

});

(function (root, insertTitleCardSceneWithTitlesCommandFactory) {
   "use strict";

   var Q = (typeof exports !== 'undefined') ? require("q") : root.Q;
   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.InsertTitleCardSceneWithTitlesCommand = insertTitleCardSceneWithTitlesCommandFactory(root, Q, namespace.commandNames, namespace.defaultSceneValues, namespace.themeablesDictionary, namespace.sceneType, namespace.Scene, namespace.InsertSceneCommand);

})(this, function (root, Q, commandNames, defaultSceneValues, themeablesDictionary, sceneType, Scene, InsertSceneCommand) {

   "use strict";

      /**
    * @memberof tscml
    * @class InsertTitleCardSceneWithTitlesCommand
    * @param {tscml.SceneTrack} sceneTrack - Reference to the SceneTrack to execute command on.
    * @param {Number} index - The index to insert new Scene at.
    * @param {String} titleCardType - One of 'intro', 'title', or 'outro' to select the title card type.
    * @param {Array} themeableProperties - Array of objects with two attributes like: { propName: '<name of the property>', value: '<value for the property>' }.
    * @param {Object} [options] - Information about the scene to be added.
    * @param {String} [options.id] - Id to use with Scene.
    * @param {String} [options.title=""] - Title of the scene.
    * @param {Number} [options.duration=0] - Duration of scene.
    * @classdesc Inserts a Scene at a specific index in a SceneTrack.
    */
   var InsertTitleCardSceneWithTitlesCommand = function (sceneTrack, index, titleCardType, themeableProperties, options) {
      var _commandName,
         _addedScene,
         _public,
         _insertSceneCommand;

      options.type = titleCardType;

      _insertSceneCommand = InsertSceneCommand.create(sceneTrack, index, options);

      _commandName = commandNames.INSERT_TITLE_CARD_SCENE_WITH_TITLES;

      _public = Object.defineProperties({}, {
         commandName: {
            value: _commandName
         }
      });

      var convertPropertiesToThemeDef = function (titleCardType, themeableProperties) {
         var result = [
            { themeTag: titleCardType + 'Background' }
         ];

         for (var i = 0; i < themeableProperties.length; i++) {
            result.push({ themeTag: themeableProperties[i].propName, def: { text: themeableProperties[i].value } });
         }

         return result;
      };

      /**
       *  Execute the insert scene command
       *  @function execute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to execute.
       *  @memberof tscml.InsertTitleCardSceneWithTitlesCommand
       *  @return {Object} Q Promise that resolves with the inserted Scene.
       */
      _public.execute = function (commandHelper) {
         try {
            if (themeableProperties.length === 0 ) {
               options.themeables = themeableProperties;
            } else {
               options.themeables = convertPropertiesToThemeDef(titleCardType, themeableProperties);
            }

            return _insertSceneCommand.execute(commandHelper);
         } catch (error) {
            return Q.reject(error);
         }
      };

      /**
       *  Un-execute the insert scene command
       *  @function unExecute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to un-execute.
       *  @memberof tscml.InsertTitleCardSceneWithTitlesCommand
       *  @return {Object} Q Promise that resolves when the command has been successfully undone.
       */
      _public.unExecute = _insertSceneCommand.unExecute;

      return _public;
   };

   return {
      /**
       *  Factory method that returns a new InsertTitleCardSceneWithTitlesCommand object.
       *  @function create
       *  @memberof tscml.InsertTitleCardSceneWithThemeableDefPropertiesCommand object
       *  @param {tscml.SceneTrack} sceneTrack - Reference to the SceneTrack to execute command on.
       *  @param {Number} index - The index to insert new Scene at.
       *  @param {String} titleCardType - One of 'intro', 'title', or 'outro' to select the title card type.
       *  @param {Array} themeableProperties - Array of objects with two attributes like: { propName: '<name of the property>', value: '<value for the property>' }.
       *  @param {Object} options - Optional information about the scene to be added.
       *  @param {String} [options.id] - Id to use with Scene.
       *  @param {String} [options.title=""] - Title of the scene.
       *  @param {Number} [options.duration=0] - Duration of scene.
       *  @static
       *  @return {tscml.InsertTitleCardSceneWithTitlesCommand} new InsertTitleCardSceneWithTitlesCommand instance
       */
      create: function (sceneTrack, index, titleCardType, themeableProperties, options) {
         options = options || {};
         if ( options.type ) {
            throw new Error('InsertTitleCardSceneWithTitlesCommand: Cannot set options.type to anything with InsertTitleCardSceneWithTitlesCommand.');
         }
         return new InsertTitleCardSceneWithTitlesCommand(sceneTrack, index, titleCardType, themeableProperties, options);
      }
   };
});


(function (root, appendSceneCommandFactory) {
   "use strict";

   var Q = (typeof exports !== 'undefined') ? require("q") : root.Q;
   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.AppendSceneCommand = appendSceneCommandFactory(root, namespace.InsertSceneCommand);

})(this, function (root, InsertSceneCommand) {

   "use strict";

   /**
    * @memberof tscml
    * @class AppendSceneCommand
    * @classdesc Convenience wrapper around InsertSceneCommand.
    */

   return {
      /**
       *  Factory method is a convenience wrapper around InsertSceneCommand.
       *  @function create
       *  @memberof tscml.AppendSceneCommand
       *  @param {tscml.SceneTrack} sceneTrack - Reference to the scene track to execute command on.
       *  @param {Object} options - Optional information about the scene to be added.
       *  @param {String} [options.title=""] - Title of the scene.
       *  @param {String} [options.type="content"] - Scene type
       *  @param {Number} [options.duration=0] - Duration of scene.
       *  @static
       *  @return {tscml.InsertSceneCommand} new InsertSceneCommand instance
       */
      create: function (sceneTrack, options) {
         var index = sceneTrack.numberScenes;
         return InsertSceneCommand.create(sceneTrack, index, options);
      }
   };

});

(function (root, removeSceneCommandFactory) {
   "use strict";

   var Q = (typeof exports !== 'undefined') ? require("q") : root.Q;
   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.RemoveSceneCommand = removeSceneCommandFactory(root, Q, namespace.commandNames);

})(this, function (root, Q, commandNames) {

   "use strict";

   /**
    * @memberof tscml
    * @class RemoveSceneCommand
    * @param {tscml.SceneTrack} sceneTrack - Reference to the track to execute command on.
    * @param {Number} index - The index to remove Scene at.
    * @classdesc Removes a Scene from a SceneTrack
    */
   var RemoveSceneCommand = function (sceneTrack, index) {
      var _commandName,
         _removedScene,
         _public;

      _commandName = commandNames.REMOVE_SCENE;

      _public = Object.defineProperties({}, {
         commandName: {
            value: _commandName
         }
      });

      /**
       *  Execute the remove scene source command
       *  @function execute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to execute.
       *  @memberof tscml.RemoveSceneCommand
       *  @return {Object} Q Promise that resolves with the removed Scene.
       */
      _public.execute = function (commandHelper) {
         var defer = Q.defer();

         try {
            var sceneTrackCommandInterface = commandHelper.getCommandInterface(sceneTrack);
            _removedScene = sceneTrackCommandInterface.removeSceneAtIndex(index);
            defer.resolve(_removedScene);
         } catch (error) {
            defer.reject(error);
         }

         return defer.promise;
      };

      /**
       *  Un-execute the remove scene source command
       *  @function unExecute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to un-execute.
       *  @memberof tscml.RemoveSceneCommand
       *  @return {Object} Q Promise that resolves when the command has been successfully undone.
       */
      _public.unExecute = function (commandHelper) {
         var defer = Q.defer();

         if (_removedScene) {
            try {
               var sceneTrackCommandInterface = commandHelper.getCommandInterface(sceneTrack);
               sceneTrackCommandInterface.insertSceneAtIndex(_removedScene, index);
               defer.resolve();
            } catch (error) {
               defer.reject(error);
            }
         } else {
            defer.resolve();
         }

         return defer.promise;
      };

      return _public;
   };

   return {
      /**
       *  Factory method that returns a new RemoveSceneCommand object.
       *  @function create
       *  @memberof tscml.RemoveSceneCommand
       *  @param {tscml.SceneTrack} sceneTrack - Reference to the track to execute command on.
       *  @param {Number} index - The index to remove Scene at.
       *  @static
       *  @return {tscml.RemoveSceneCommand} new RemoveSceneCommand instance
       */
      create: function (sceneTrack, index) {
         return new RemoveSceneCommand(sceneTrack, index);
      }
   };

});

(function (root, moveSceneCommandFactory) {
   "use strict";

   var Q = (typeof exports !== 'undefined') ? require("q") : root.Q;
   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.MoveSceneCommand = moveSceneCommandFactory(root, Q, namespace.commandNames);

})(this, function (root, Q, commandNames) {

   "use strict";

   /**
    * @memberof tscml
    * @class MoveSceneCommand
    * @param {tscml.SceneTrack} sceneTrack - Reference to the SceneTrack to execute command on.
    * @param {Number} fromIndex - The index of scene to move.
    * @param {Number} toIndex - Where to move scene to.
    * @classdesc Moves a Scene from one index to another within a SceneTrack.
    */
   var MoveSceneCommand = function (sceneTrack, fromIndex, toIndex) {
      var _commandName,
         _moveExecuted,
         _public;

      _commandName = commandNames.MOVE_SCENE;
      _moveExecuted = false;

      _public = Object.defineProperties({}, {
         commandName: {
            value: _commandName
         }
      });

      /**
       *  Execute the move scene source command
       *  @function execute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to execute.
       *  @memberof tscml.MoveSceneCommand
       *  @return {Object} Q Promise that resolves when the scene has been successfully moved.
       */
      _public.execute = function (commandHelper) {
         var defer = Q.defer();

         try {
            var sceneTrackCommandInterface = commandHelper.getCommandInterface(sceneTrack);
            sceneTrackCommandInterface.moveSceneAtIndex(fromIndex, toIndex);
            _moveExecuted = true;
            defer.resolve();
         } catch (error) {
            defer.reject(error);
         }

         return defer.promise;
      };

      /**
       *  Un-execute the move scene source command
       *  @function unExecute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to un-execute.
       *  @memberof tscml.MoveSceneCommand
       *  @return {Object} Q Promise that resolves when the command has been successfully undone.
       */
      _public.unExecute = function (commandHelper) {
         var defer = Q.defer();

         if (_moveExecuted) {
            try {
               var sceneTrackCommandInterface = commandHelper.getCommandInterface(sceneTrack);
               sceneTrackCommandInterface.moveSceneAtIndex(toIndex, fromIndex);
               defer.resolve();
            } catch (error) {
               defer.reject(error);
            }
         } else {
            defer.resolve();
         }

         return defer.promise;
      };

      return _public;
   };

   return {
      /**
       *  Factory method that returns a new MoveSceneCommand object.
       *  @function create
       *  @memberof tscml.MoveSceneCommand
       *  @param {tscml.SceneTrack} sceneTrack - Reference to the SceneTrack to execute command on.
       *  @param {Number} fromIndex - The index of scene to move.
       *  @param {Number} toIndex - Where to move scene to.
       *  @static
       *  @return {tscml.MoveSceneCommand} new MoveSceneCommand instance
       */
      create: function (sceneTrack, fromIndex, toIndex) {
         return new MoveSceneCommand(sceneTrack, fromIndex, toIndex);
      }
   };

});

(function (root, setSourceMimeTypeCommandFactory) {
   "use strict";

   var Q = (typeof exports !== 'undefined') ? require("q") : root.Q;
   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.SetSourceMimeTypeCommand = setSourceMimeTypeCommandFactory(root, Q, namespace.commandNames);

})(this, function (root, Q, commandNames) {

   "use strict";

   /**
    * @memberof tscml
    * @class SetSourceMimeTypeCommand
    * @param {tscml.Source} source - Reference to the Source to execute command on.
    * @param {String} mimeType - source mimeType.
    * @classdesc Sets the mimeType of the source.
    */
   var SetSourceMimeTypeCommand = function (source, mimeType) {
      var _commandName,
         _previousMimeType,
         _public;

      _commandName = commandNames.SET_SOURCE_MIME_TYPE;

      _public = Object.defineProperties({}, {
         commandName: {
            value: _commandName
         }
      });

      /**
       *  Execute the set mimeType command.
       *  @function execute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to execute.
       *  @memberof tscml.SetSourceMimeTypeCommand
       *  @return {Object} Q Promise that resolves when the source mimeType has been updated.
       */
      _public.execute = function (commandHelper) {
         var defer = Q.defer();

         try {
            var sourceCommandInterface = commandHelper.getCommandInterface(source);
            _previousMimeType = source.mimeType;
            sourceCommandInterface.setMimeType(mimeType);
            defer.resolve();
         } catch (error) {
            defer.reject(error);
         }

         return defer.promise;
      };

      /**
       *  Un-execute the set mimeType command.
       *  @function unExecute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to un-execute.
       *  @memberof tscml.SetSourceMimeTypeCommand
       *  @return {Object} Q Promise that resolves when the command has been successfully undone.
       */
      _public.unExecute = function (commandHelper) {
         var defer = Q.defer();

         if (typeof _previousMimeType != "undefined") {
            try {
               var sourceCommandInterface = commandHelper.getCommandInterface(source);
               sourceCommandInterface.setMimeType(_previousMimeType);
               defer.resolve();
            } catch (error) {
               defer.reject(error);
            }
         } else {
            defer.resolve();
         }

         return defer.promise;
      };

      return _public;
   };

   return {
      /**
       *  Factory method that returns a new SetSourceMimeTypeCommand object.
       *  @function create
       *  @memberof tscml.SetSourceMimeTypeCommand
       *  @param {tscml.Source} source - Reference to the source to execute command on.
       *  @param {String} mimeType - source mimeType.
       *  @static
       *  @return {tscml.SetSourceMimeTypeCommand} new SetSourceMimeTypeCommand instance
       */
      create: function (source, mimeType) {
         return new SetSourceMimeTypeCommand(source, mimeType);
      }
   };

});

(function (root, setThemeFileCommandFactory) {
   "use strict";

   var Q = (typeof exports !== 'undefined') ? require("q") : root.Q;
   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.SetThemeFileCommand = setThemeFileCommandFactory(root, Q, namespace.commandNames);

})(this, function (root, Q, commandNames) {

   "use strict";

   /**
    * @memberof tscml
    * @class SetThemeFileCommand
    * @param {tscml.Project} project - Reference to the Project to execute command on.
    * @param {String} themeFile - Theme file to store in project.
    * @classdesc Set value for Theme file on a project.
    */
   var SetThemeFileCommand = function (project, themeFile) {
      var _commandName,
         _oldThemeFile,
         _public;

      _commandName = commandNames.SET_THEME_FILE;

      _public = Object.defineProperties({}, {
         commandName: {
            value: _commandName
         }
      });

      /**
       *  Execute the set theme file command
       *  @function execute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to execute.
       *  @memberof tscml.SetThemeFileCommand
       *  @return {Object} Q Promise that resolves when the scene has been successfully moved.
       */
      _public.execute = function (commandHelper) {
         var defer = Q.defer();

         try {
            var projectCommandInterface = commandHelper.getCommandInterface(project);
            _oldThemeFile = project.themeFile;
            projectCommandInterface.setThemeFile(themeFile);
            defer.resolve();
         } catch (error) {
            defer.reject(error);
         }

         return defer.promise;
      };

      /**
       *  Un-execute the set theme file command
       *  @function unExecute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to un-execute.
       *  @memberof tscml.SetThemeFileCommand
       *  @return {Object} Q Promise that resolves when the command has been successfully undone.
       */
      _public.unExecute = function (commandHelper) {
         var defer = Q.defer();

         if (typeof _oldThemeFile !== "undefined") {
            try {
               var projectCommandInterface = commandHelper.getCommandInterface(project);
               projectCommandInterface.setThemeFile(_oldThemeFile.uri);
               defer.resolve();
            } catch (error) {
               defer.reject(error);
            }
         } else {
            defer.resolve();
         }

         return defer.promise;
      };

      return _public;
   };

   return {
      /**
       *  Factory method that returns a new SetThemeFileCommand object.
       *  @function create
       *  @memberof tscml.SetThemeFileCommand
       *  @param {tscml.Project} project - Reference to the Project to execute command on.
       *  @param {String} themeFile - Theme file to store in project.
       *  @static
       *  @return {tscml.SetThemeFileCommand} new SetThemeFileCommand instance
       */
      create: function (project, themeFile) {
         return new SetThemeFileCommand(project, themeFile);
      }
   };

});

(function (root, setProjectMetadataFactory) {
   "use strict";

   var Q = (typeof exports !== 'undefined') ? require("q") : root.Q;
   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.SetProjectMetadataCommand = setProjectMetadataFactory(root, Q, namespace.commandNames);

})(this, function (root, Q, commandNames) {

   "use strict";

   /**
    * @memberof tscml
    * @class SetProjectMetadataCommand
    * @param {tscml.Project} project - Reference to the Project to execute command on.
    * @param {String} key - Metadata key you are setting.
    * @param {*} value - Value for metadata key you are setting (if you pass in null it will unset and remove the metadata field).
    * @classdesc Set a metadata value at the project level
    */
   var SetProjectMetadataCommand = function (project, key, value) {
      var _commandName;
      var _oldValue;
      var _public;

      _commandName = commandNames.SET_PROJECT_METADATA;

      _public = Object.defineProperties({}, {
         commandName: {
            value: _commandName
         }
      });

      /**
       *  Execute the set project metadata command
       *  @function execute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to execute.
       *  @memberof tscml.SetProjectMetadataCommand
       *  @return {Object} Q Promise that resolves when the scene has been successfully moved.
       */
      _public.execute = function (commandHelper) {
         var defer = Q.defer();

         try {
            var projectCommandInterface = commandHelper.getCommandInterface(project);
            _oldValue = project.getMetadataValue(key);
            projectCommandInterface.setMetadataValue(key, value);
            defer.resolve();
         } catch (error) {
            defer.reject(error);
         }

         return defer.promise;
      };

      /**
       *  Un-execute the set scene type command.
       *  @function unExecute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to un-execute.
       *  @memberof tscml.SetSceneTypeCommand
       *  @return {Object} Q Promise that resolves when the command has been successfully undone.
       */
      _public.unExecute = function (commandHelper) {
         var defer = Q.defer();

         if (_oldValue !== undefined)
         {
            try {
               var projectCommandInterface = commandHelper.getCommandInterface(project);
               projectCommandInterface.setMetadataValue(key, _oldValue);
               defer.resolve();
            } catch (error) {
               defer.reject(error);
            }
         } else {
            defer.resolve();
         }

         return defer.promise;
      };

      return _public;
   };

   return {
      /**
       *  Factory method that returns a new SetSceneTypeCommand object.
       *  @function create
       *  @memberof tscml.SetProjectMetadataCommand
       *  @param {tscml.Project} project - Reference to the Project to execute command on.
       *  @param {String} key - Metadata key you are setting.
       *  @param {Object} value - Value for metadata key you are setting (if you pass in null here it will unset and remove the metadata field).
       *  @static
       *  @return {tscml.SetProjectMetadataCommand} new SetProjectMetadataCommand instance
       */
      create: function (project, key, value) {
         return new SetProjectMetadataCommand(project, key, value);
      }
   };
});

(function (root, setSceneTitleCommandFactory) {
   "use strict";

   var Q = (typeof exports !== 'undefined') ? require("q") : root.Q;
   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.SetSceneTitleCommand = setSceneTitleCommandFactory(root, Q, namespace.commandNames);

})(this, function (root, Q, commandNames) {

   "use strict";

   /**
    * @memberof tscml
    * @class SetSceneTitleCommand
    * @param {tscml.Scene} scene - Reference to the Scene to execute command on.
    * @param {String} title - Scene title.
    * @classdesc Sets the title of the Scene.
    */
   var SetSceneTitleCommand = function (scene, title) {
      var _commandName,
         _oldTitle,
         _public;

      _commandName = commandNames.SET_SCENE_TITLE;

      _public = Object.defineProperties({}, {
         commandName: {
            value: _commandName
         }
      });

      /**
       *  Execute the set title command.
       *  @function execute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to execute.
       *  @memberof tscml.SetSceneTitleCommand
       *  @return {Object} Q Promise that resolves when the scene has been successfully moved.
       */
      _public.execute = function (commandHelper) {
         var defer = Q.defer();

         try {
            var sceneCommandInterface = commandHelper.getCommandInterface(scene);
            _oldTitle = scene.title;
            sceneCommandInterface.setTitle(title);
            defer.resolve();
         } catch (error) {
            defer.reject(error);
         }

         return defer.promise;
      };

      /**
       *  Un-execute the set title command.
       *  @function unExecute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to un-execute.
       *  @memberof tscml.SetSceneTitleCommand
       *  @return {Object} Q Promise that resolves when the command has been successfully undone.
       */
      _public.unExecute = function (commandHelper) {
         var defer = Q.defer();

         if (typeof _oldTitle != "undefined") {
            try {
               var sceneCommandInterface = commandHelper.getCommandInterface(scene);
               sceneCommandInterface.setTitle(_oldTitle);
               defer.resolve();
            } catch (error) {
               defer.reject(error);
            }
         } else {
            defer.resolve();
         }

         return defer.promise;
      };

      return _public;
   };

   return {
      /**
       *  Factory method that returns a new SetSceneTitleCommand object.
       *  @function create
       *  @memberof tscml.SetSceneTitleCommand
       *  @param {tscml.Scene} scene - Reference to the Scene to execute command on.
       *  @param {String} title - Scene title.
       *  @static
       *  @return {tscml.SetSceneTitleCommand} new SetSceneTitleCommand instance
       */
      create: function (scene, title) {
         return new SetSceneTitleCommand(scene, title);
      }
   };

});

(function (root, setSceneDurationCommandFactory) {
   "use strict";

   var Q = (typeof exports !== 'undefined') ? require("q") : root.Q;
   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.SetSceneDurationCommand = setSceneDurationCommandFactory(root, Q, namespace.commandNames);

})(this, function (root, Q, commandNames) {

   "use strict";

   /**
    * @memberof tscml
    * @class SetSceneDurationCommand
    * @param {tscml.Scene} scene - Reference to the Scene to execute command on.
    * @param {Number} duration - Duration
    * @classdesc Set the duration of a scene.
    */
   var SetSceneDurationCommand = function (scene, duration) {
      var _commandName,
         _oldDuration,
         _public;

      _commandName = commandNames.SET_SCENE_DURATION;

      _public = Object.defineProperties({}, {
         commandName: {
            value: _commandName
         }
      });

      /**
       *  Execute the set duration command.
       *  @function execute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to execute.
       *  @memberof tscml.SetSceneDurationCommand
       *  @return {Object} Q Promise that resolves when the scene has been successfully moved.
       */
      _public.execute = function (commandHelper) {
         var defer = Q.defer();

         try {
            var sceneCommandInterface = commandHelper.getCommandInterface(scene);
            _oldDuration = scene.duration;
            sceneCommandInterface.setDuration(duration);
            defer.resolve();
         } catch (error) {
            defer.reject(error);
         }

         return defer.promise;
      };

      /**
       *  Un-execute the set title command.
       *  @function unExecute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to un-execute.
       *  @memberof tscml.SetSceneTitleCommand
       *  @return {Object} Q Promise that resolves when the command has been successfully undone.
       */
      _public.unExecute = function (commandHelper) {
         var defer = Q.defer();

         if (typeof _oldDuration != "undefined") {
            try {
               var sceneCommandInterface = commandHelper.getCommandInterface(scene);
               sceneCommandInterface.setDuration(_oldDuration);
               defer.resolve();
            } catch (error) {
               defer.reject(error);
            }
         } else {
            defer.resolve();
         }

         return defer.promise;
      };

      return _public;
   };

   return {
      /**
       *  Factory method that returns a new SetSceneDurationCommand object.
       *  @function create
       *  @memberof tscml.SetSceneDurationCommand
       *  @param {tscml.Scene} scene - Reference to the Scene to execute command on.
       *  @param {Number} duration - Scene title.
       *  @static
       *  @return {tscml.SetSceneDurationCommand} new SetSceneTitleCommand instance
       */
      create: function (scene, duration) {
         return new SetSceneDurationCommand(scene, duration);
      }
   };
});

(function (root, setSceneNarrationCommandFactory) {
   "use strict";

   var Q = (typeof exports !== 'undefined') ? require("q") : root.Q;
   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.SetSceneAudioNarrationCommand = setSceneNarrationCommandFactory(root, Q, namespace.commandNames);

})(this, function (root, Q, commandNames) {

   "use strict";

   /**
    * @memberof tscml
    * @class SetSceneAudioNarrationCommand
    * @param {tscml.Scene} scene - Reference to the Scene to execute command on.
    * @param {String} uri - Uri to the audio narration.
    * @param {String} mimeType - Mime type for the audio narration file.
    * @classdesc Sets the narration data of the Scene.
    */
   var SetSceneAudioNarrationCommand = function (scene, uri, mimeType) {
      var _commandName,
         _previousAudioNarration,
         _public;

      _commandName = commandNames.SET_SCENE_AUDIO_NARRATION;

      _public = Object.defineProperties({}, {
         commandName: {
            value: _commandName
         }
      });

      /**
       *  Execute the set audio narration command.
       *  @function execute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to execute.
       *  @memberof tscml.SetSceneAudioNarrationCommand
       *  @return {Object} Q Promise that resolves when the scene has been successfully moved.
       */
      _public.execute = function (commandHelper) {
         var defer = Q.defer();

         try {
            var sceneCommandInterface = commandHelper.getCommandInterface(scene);
            _previousAudioNarration = scene.audioNarration;
            sceneCommandInterface.setAudioNarration({uri: uri, mimeType: mimeType});
            defer.resolve();
         } catch (error) {
            defer.reject(error);
         }

         return defer.promise;
      };

      /**
       *  Un-execute the set audio narration command.
       *  @function unExecute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to un-execute.
       *  @memberof tscml.SetSceneAudioNarrationCommand
       *  @return {Object} Q Promise that resolves when the command has been successfully undone.
       */
      _public.unExecute = function (commandHelper) {
         var defer = Q.defer();

         if (typeof _previousAudioNarration != "undefined") {
            try {
               var sceneCommandInterface = commandHelper.getCommandInterface(scene);
               sceneCommandInterface.setAudioNarration(_previousAudioNarration);
               defer.resolve();
            } catch (error) {
               defer.reject(error);
            }
         } else {
            defer.resolve();
         }

         return defer.promise;
      };

      return _public;
   };

   return {
      /**
       *  Factory method that returns a new SetSceneAudioNarrationCommand object.
       *  @function create
       *  @memberof tscml.SetSceneAudioNarrationCommand
       *  @param {tscml.Scene} scene - Reference to the Scene to execute command on.
       *  @param {String} uri - Uri to the audio narration.
       *  @param {String} mimeType - Mime type for the audio narration file.
       *  @static
       *  @return {tscml.SetSceneAudioNarrationCommand} new SetSceneAudioNarrationCommand instance
       */
      create: function (scene, uri, mimeType) {
         return new SetSceneAudioNarrationCommand(scene, uri, mimeType);
      }
   };

});

(function (root, setSceneAudioNarrationWithDurationCommandFactory) {
   "use strict";

   var Q = (typeof exports !== 'undefined') ? require("q") : root.Q;
   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.SetSceneAudioNarrationWithDurationCommand =
      setSceneAudioNarrationWithDurationCommandFactory(root, Q, namespace.commandNames, namespace.MultiCommand, namespace.SetSceneAudioNarrationCommand, namespace.SetSceneDurationCommand);

})(this, function (root, Q, commandNames, MultiCommand, SetSceneAudioNarrationCommand, SetSceneDurationCommand) {

   "use strict";

   /**
    * @memberof tscml
    * @class SetSceneAudioNarrationWithDurationCommand
    * @augments tscml.MultiCommand
    * @param {tscml.Scene} scene - Reference to the scene to execute command on.
    * @param {String} uri - Uri for the audio narration file.
    * @param {String} mimeType - Mime type for the audio narration file.
    * @param {Number} duration - Duration of the audio narration in seconds (floating point).
    * @classdesc Set audio narration with duration on a scene.
    */
   var SetSceneAudioNarrationWithDurationCommand = function (scene, uri, mimeType, duration) {
      this.handleExecute = function (commandHelper, multiCommandHelper) {
         return multiCommandHelper.executeCommand(SetSceneAudioNarrationCommand.create(scene, uri, mimeType))
            .then(function () {
               return multiCommandHelper.executeCommand(SetSceneDurationCommand.create(scene, duration));
            });
      };

      return MultiCommand.call(this, commandNames.SET_SCENE_AUDIO_NARRATION_WITH_DURATION);
   };

   return {
      /**
       *  Factory method that returns a new SetSceneAudioNarrationWithDurationCommand object.
       *  @function create
       *  @memberof tscml.SetSceneAudioNarrationWithDurationCommand
       *  @param {tscml.Scene} scene - Reference to the scene to execute command on.
       *  @param {String} uri - Uri for the audio narration file.
       *  @param {String} mimeType - Mime type for the audio narration file.
       *  @param {Number} duration - Duration of the audio narration in seconds (floating point).
       *  @static
       *  @return {tscml.SetSceneAudioNarrationWithDurationCommand} new SetSceneAudioNarrationWithDurationCommand instance
       */
      create: function (scene, uri, mimeType, duration) {
         return new SetSceneAudioNarrationWithDurationCommand(scene, uri, mimeType, duration);
      }
   };

});

(function (root, removeSceneNarrationCommandFactory) {
   "use strict";

   var Q = (typeof exports !== 'undefined') ? require("q") : root.Q;
   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.RemoveSceneAudioNarrationCommand = removeSceneNarrationCommandFactory(root, Q, namespace.commandNames);

})(this, function (root, Q, commandNames) {

   "use strict";

   /**
    * @memberof tscml
    * @class RemoveSceneAudioNarrationCommand
    * @param {tscml.Scene} scene - Reference to the Scene to execute command on.
    * @classdesc Removes the narration data of the Scene.
    */
   var RemoveSceneAudioNarrationCommand = function (scene) {
      var _commandName,
         _previousAudioNarration,
         _public;

      _commandName = commandNames.REMOVE_SCENE_AUDIO_NARRATION;

      _public = Object.defineProperties({}, {
         commandName: {
            value: _commandName
         }
      });

      /**
       *  Execute the set audio narration command.
       *  @function execute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to execute.
       *  @memberof tscml.RemoveSceneAudioNarrationCommand
       *  @return {Object} Q Promise that resolves when the scene has been successfully moved.
       */
      _public.execute = function (commandHelper) {
         var defer = Q.defer();

         try {
            var sceneCommandInterface = commandHelper.getCommandInterface(scene);
            _previousAudioNarration = scene.audioNarration;
            sceneCommandInterface.removeAudioNarration();
            defer.resolve();
         } catch (error) {
            defer.reject(error);
         }

         return defer.promise;
      };

      /**
       *  Un-execute the remove audio narration command.
       *  @function unExecute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to un-execute.
       *  @memberof tscml.RemoveSceneAudioNarrationCommand
       *  @return {Object} Q Promise that resolves when the command has been successfully undone.
       */
      _public.unExecute = function (commandHelper) {
         var defer = Q.defer();

         if (typeof _previousAudioNarration != "undefined" && _previousAudioNarration !== null) {
            try {
               var sceneCommandInterface = commandHelper.getCommandInterface(scene);
               sceneCommandInterface.setAudioNarration(_previousAudioNarration);
               defer.resolve();
            } catch (error) {
               defer.reject(error);
            }
         } else {
            defer.resolve();
         }

         return defer.promise;
      };

      return _public;
   };

   return {
      /**
       *  Factory method that returns a new RemoveSceneAudioNarrationCommand object.
       *  @function create
       *  @memberof tscml.RemoveSceneAudioNarrationCommand
       *  @param {tscml.Scene} scene - Reference to the Scene to execute command on.
       *  @static
       *  @return {tscml.RemoveSceneAudioNarrationCommand} new RemoveSceneAudioNarrationCommand instance
       */
      create: function (scene) {
         return new RemoveSceneAudioNarrationCommand(scene);
      }
   };

});

(function (root, setThemeablePropertyCommandFactory) {
   "use strict";

   var Q = (typeof exports !== 'undefined') ? require("q") : root.Q;
   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.SetThemeableDefPropertyCommand = setThemeablePropertyCommandFactory(root, Q, namespace.commandNames);

})(this, function (root, Q, commandNames) {

   "use strict";

   /**
    * @memberof tscml
    * @class SetThemeableDefPropertyCommand
    * @param {tscml.Scene} scene - Reference to the Scene to execute command on.
    * @param {String} themeTag - Theme tag string to set property value on.
    * @param {String} defProperty - Property name to set new value on.
    * @param {String|Number|Boolean} value - Value to set to theme tag def property.
    * @classdesc Sets new value of the themeable theme tag def property.
    */
   var SetThemeableDefPropertyCommand = function (scene, themeTag, defProperty, value) {
      var _commandName,
         _oldPropertyValue,
         _public;

      _commandName = commandNames.SET_THEMEABLE_DEF_PROPERTY;

      _public = Object.defineProperties({}, {
         commandName: {
            value: _commandName
         }
      });

      /**
       *  Execute the set title command.
       *  @function execute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to execute.
       *  @memberof tscml.SetThemeableDefPropertyCommand
       *  @return {Object} Q Promise that resolves when the scene has been successfully moved.
       */
      _public.execute = function (commandHelper) {
         var defer = Q.defer();

         try {
            var sceneCommandInterface = commandHelper.getCommandInterface(scene);
            _oldPropertyValue = scene.getThemeTagDefPropertyValue(themeTag, defProperty);
            sceneCommandInterface.setThemeTagDefProperty(themeTag, defProperty, value);
            defer.resolve();
         } catch (error) {
            defer.reject(error);
         }

         return defer.promise;
      };

      /**
       *  Un-execute the set new value of the themeable theme tag def property.
       *  @function unExecute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to un-execute.
       *  @memberof tscml.SetThemeableDefPropertyCommand
       *  @return {Object} Q Promise that resolves when the command has been successfully undone.
       */
      _public.unExecute = function (commandHelper) {
         var defer = Q.defer();

         if (typeof _oldPropertyValue != "undefined") {
            try {
               var sceneCommandInterface = commandHelper.getCommandInterface(scene);
               sceneCommandInterface.setThemeTagDefProperty(themeTag, defProperty, _oldPropertyValue);
               defer.resolve();
            } catch (error) {
               defer.reject(error);
            }
         } else {
            defer.resolve();
         }

         return defer.promise;
      };

      return _public;
   };

   return {
      /**
       *  Factory method that returns a new SetThemeableDefPropertyCommand object.
       *  @function create
       *  @memberof tscml.SetThemeableDefPropertyCommand
       *  @param {tscml.Scene} scene - Reference to the Scene to execute command on.
       *  @param {String} themeTag - Theme tag string to set property value on.
       *  @param {String} defProperty - Property name to set new value on.
       *  @param {String|Number|Boolean} value - Value to set to theme tag def property.
       *  @static
       *  @return {tscml.SetThemeableDefPropertyCommand} new SetThemeableDefPropertyCommand instance
       */
      create: function (scene, themeTag, defProperty, value) {
         if (!scene.isThemeable()) {
            throw new Error("SetThemeableDefPropertyCommand: Scene supplied is not themeable.");
         } else if (!scene.hasThemeTag(themeTag)) {
            throw new Error("SetThemeableDefPropertyCommand: Scene supplied does not have a themeTag(" + themeTag + ").");
         } else if (!scene.hasThemeTagDefProperty(themeTag, defProperty)) {
            throw new Error("SetThemeableDefPropertyCommand: Scene supplied does not have a def property(" + defProperty + ") for themeTag(" + themeTag + ").");
         }
         return new SetThemeableDefPropertyCommand(scene, themeTag, defProperty, value);
      }
   };

});

(function (root, addSceneSourceCommandFactory) {
   "use strict";

   var Q = (typeof exports !== 'undefined') ? require("q") : root.Q;
   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.AddSceneSourceCommand = addSceneSourceCommandFactory(root, Q, namespace.commandNames, namespace.Source, namespace.sceneType);

})(this, function (root, Q, commandNames, Source, sceneType) {

   "use strict";

   /**
    * @memberof tscml
    * @class AddSceneSourceCommand
    * @param {tscml.Scene} scene - Reference to the scene to execute command on.
    * @param {Object} sourceInfo - Information about the source to be added.
    * @param {String} sourceInfo.uri - Location of the source. Can be any value that is understood by one of the registered statLoaders.
    * @param {Number} [sourceInfo.duration] - Duration of the source in seconds (floating point).  If not provided, a statLoader will be used to determine it
    * @param {String} [sourceInfo.mimeType] - Mime type of the source (ex. "video/mp4").  If not provided, a statLoader will be used to determine it.
    * @classdesc Adds a Source to a Scene.
    */
   var AddSceneSourceCommand = function (scene, sourceInfo) {
      var _commandName,
         _addedSource,
         _previousDuration,
         _public;

      _commandName = commandNames.ADD_SCENE_SOURCE;

      _public = Object.defineProperties({}, {
         commandName: {
            value: _commandName
         }
      });

      var canStatLoaderHandleUri = function (statLoader, uri) {
         var defer = Q.defer();
         statLoader.canHandleUri(uri,
            function (canHandle) {
               defer.resolve({canHandle: canHandle, statLoader: statLoader});
            },
            function (error) {
               defer.reject(error);
            }
         );
         return defer.promise;
      };

      var findStatLoaderThatCanHandleUri = function (uri, statLoaders) {
         var defer = Q.defer();

         var promises = [];
         statLoaders.forEach(function (statLoader) {
            promises.push(canStatLoaderHandleUri(statLoader, uri));
         });

         Q.allSettled(promises).then(
            function (results) {
               var statLoaderFound = false;
               results.forEach(
                  function (result) {
                     if (result.state === 'fulfilled' && result.value.canHandle && !statLoaderFound) {
                        statLoaderFound = true;
                        defer.resolve(result.value.statLoader);
                     }
                  }
               );

               if (!statLoaderFound) {
                  defer.reject(new Error("ADD-SCENE-SOURCE-COMMAND: Could not find a Stat Loader that could handle uri: " + uri));
               }
            }
         );

         return defer.promise;
      };

      var getInformationFromStatLoader = function (statLoader, uri) {
         var defer = Q.defer();
         statLoader.getInformationForUri(uri,
            function (info) {
               info.duration = sourceInfo.duration ? sourceInfo.duration : info.duration;
               info.mimeType = sourceInfo.mimeType ? sourceInfo.mimeType : info.mimeType;
               defer.resolve(info);
            },
            defer.reject
         );
         return defer.promise;
      };

      var getInformationForUri = function (uri, commandHelper) {
         if (sourceInfo.duration && sourceInfo.mimeType) {
            return Q({duration: sourceInfo.duration, mimeType: sourceInfo.mimeType});
         }

         var statLoaders = commandHelper.getStatLoaders();
         return findStatLoaderThatCanHandleUri(uri, statLoaders).then(
            function (statLoader) {
               return getInformationFromStatLoader(statLoader, uri).then(function (info) {
                  return info;
               });
            }
         );
      };

      /**
       *  Execute the add scene source command
       *  @function execute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to execute.
       *  @memberof tscml.AddSceneSourceCommand
       *  @return {Object} Q Promise that resolves with the added source object
       */
      _public.execute = function (commandHelper) {
         return getInformationForUri(sourceInfo.uri, commandHelper).then(function (info) {
            try {
               _previousDuration = scene.duration;
               var sceneCommandInterface = commandHelper.getCommandInterface(scene);
               var addedSource = Source.create({
                  uri: sourceInfo.uri,
                  duration: info.duration,
                  mimeType: info.mimeType,
                  projectSignature: commandHelper.getProjectSignature()
               });
               sceneCommandInterface.addSource(addedSource);

               if(info.duration > scene.duration) {
                  sceneCommandInterface.setDuration(info.duration);
               }

               _addedSource = addedSource;
               return _addedSource;
            } catch (error) {
               return Q.reject(error);
            }
         });
      };

      /**
       *  Un-execute the add scene source command
       *  @function unExecute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to un-execute.
       *  @memberof tscml.AddSceneSourceCommand
       *  @return {Object} Q Promise that resolves when the command has been successfully undone.
       */
      _public.unExecute = function (commandHelper) {
         var defer = Q.defer();
         if (_addedSource) {
            try {
               var sceneCommandInterface = commandHelper.getCommandInterface(scene);
               sceneCommandInterface.removeSource(_addedSource);
               sceneCommandInterface.setDuration(_previousDuration);
               defer.resolve();
            } catch (error) {
               defer.reject(error);
            }
         } else {
            defer.resolve();
         }

         return defer.promise;
      };

      return _public;
   };

   return {
      /**
       *  Factory method that returns a new AddSceneSourceCommand object.
       *  @function create
       *  @memberof tscml.AddSceneSourceCommand
       *  @param {tscml.Scene} scene - Reference to the scene to execute command on.
       *  @param {Object} sourceInfo - Information about the source to be added.
       *  @param {String} sourceInfo.uri - Location of the source. Can be any value that is understood by one of the registered statLoaders.
       *  @param {Number} [sourceInfo.duration] - Duration of the source in seconds (floating point).  If not provided, a statLoader will be used to determine it
       *  @param {String} [sourceInfo.mimeType] - Mime type of the source (ex. "video/mp4").  If not provided, a statLoader will be used to determine it.
       *  @static
       *  @return {tscml.AddSceneSourceCommand} new AddSceneSourceCommand instance
       */
      create: function (scene, sourceInfo) {
         if (scene.type !== sceneType.CONTENT) {
            throw new Error("AddSceneSourceCommand: Scene of type(" + scene.type + ") does not support this command.");
         }
         return new AddSceneSourceCommand(scene, sourceInfo);
      }
   };
});

(function (root, addSceneWithSourceCommandFactory) {
   "use strict";

   var Q = (typeof exports !== 'undefined') ? require("q") : root.Q;
   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.AddSceneWithSourceCommand =
      addSceneWithSourceCommandFactory(root, Q, namespace.commandNames, namespace.MultiCommand, namespace.AddSceneSourceCommand, namespace.InsertSceneCommand);

})(this, function (root, Q, commandNames, MultiCommand, AddSceneSourceCommand, InsertSceneCommand) {

   "use strict";

   /**
    * @memberof tscml
    * @class AddSceneWithSourceCommand
    * @augments tscml.MultiCommand
    * @param {tscml.SceneTrack} sceneTrack - Reference to the scene track to execute command on.
    * @param {Number} index - The index to insert new Scene at.
    * @param {Object} sourceInfo - Information about the source to be added.
    * @param {String} sourceInfo.uri - Location of the source. Can be any value that is understood by one of the registered statLoaders.
    * @param {Number} [sourceInfo.duration] - Duration of the source in seconds (floating point).  If not provided, a statLoader will be used to determine it
    * @param {String} [sourceInfo.mimeType] - Mime type of the source (ex. "video/mp4").  If not provided, a statLoader will be used to determine it.
    * @param {Object} options - Optional information for the command.
    * @param {String} [options.sceneInfo] - Options for the Scene.
    * @classdesc Inserts a Scene into a SceneTrack and populates it with a Source.
    */
   var AddSceneWithSourceCommand = function (sceneTrack, index, sourceInfo, options) {
      var _addedScene,
         _addedSource;

      this.handleExecute = function (commandHelper, multiCommandHelper) {
         return multiCommandHelper.executeCommand(InsertSceneCommand.create(sceneTrack, index, options.sceneInfo))
            .then(function (addedScene) {
               _addedScene = addedScene;
               return multiCommandHelper.executeCommand(AddSceneSourceCommand.create(addedScene, sourceInfo));
            }).then(function (addedSource) {
               _addedSource = addedSource;
               return {
                  addedScene: _addedScene,
                  addedSource: _addedSource
               };
            });
      };

      return MultiCommand.call(this, commandNames.ADD_SCENE_WITH_SOURCE);
   };

   return {
      /**
       *  Factory method that returns a new AddSceneWithSourceCommand object.
       *  @function create
       *  @memberof tscml.AddSceneWithSourceCommand
       *  @param {tscml.SceneTrack} sceneTrack - Reference to the scene track to execute command on.
       *  @param {Number} index - The index to insert new Scene at.
       *  @param {Object} sourceInfo - Information about the source to be added.
       *  @param {String} sourceInfo.uri - Location of the source. Can be any value that is understood by one of the registered statLoaders.
       *  @param {Number} [sourceInfo.duration] - Duration of the source in seconds (floating point).  If not provided, a statLoader will be used to determine it
       *  @param {String} [sourceInfo.mimeType] - Mime type of the source (ex. "video/mp4").  If not provided, a statLoader will be used to determine it.
       *  @param {Object} options - Optional information for the command.
       *  @param {String} [options.sceneInfo] - Options for the Scene.
       *  @static
       *  @return {tscml.AddSceneWithSourceCommand} new AddSceneWithSourceCommand instance
       */
      create: function (sceneTrack, index, sourceInfo, options) {
         options = options || {};
         return new AddSceneWithSourceCommand(sceneTrack, index, sourceInfo, options);
      }
   };

});

(function (root, setSceneTypeCommandFactory) {
   "use strict";

   var Q = (typeof exports !== 'undefined') ? require("q") : root.Q;
   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.SetSceneTypeCommand = setSceneTypeCommandFactory(root, Q, namespace.commandNames, namespace.sceneType, namespace.themeablesDictionary);

})(this, function (root, Q, commandNames, sceneType, themeablesDictionary) {

   "use strict";

   /**
    * @memberof tscml
    * @class SetSceneTypeCommand
    * @param {tscml.Scene} scene - Scene to change type of.
    * @param {String} type - Scene type to change to.
    * @classdesc Change type of a Scene.
    */
   var SetSceneTypeCommand = function (scene, type) {
      var _commandName,
         _previousType,
         _previousThemeables,
         _public;

      _commandName = commandNames.SET_SCENE_TYPE;

      _public = Object.defineProperties({}, {
         commandName: {
            value: _commandName
         }
      });

      /**
       *  Execute the set scene type command.
       *  @function execute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to execute.
       *  @memberof tscml.SetSceneTypeCommand
       *  @return {Object} Q Promise that resolves when the scene has been successfully moved.
       */
      _public.execute = function (commandHelper) {
         var defer = Q.defer();

         try {
            var sceneCommandInterface = commandHelper.getCommandInterface(scene);
            _previousType = scene.type;
            _previousThemeables = scene.themeables;

            var params = {};
            if(type === sceneType.INTRO || type === sceneType.TITLE || type === sceneType.OUTRO) {
               params.themeables = themeablesDictionary.getThemeables(type);
            }

            sceneCommandInterface.setType(type, params);
            defer.resolve();
         } catch (error) {
            defer.reject(error);
         }

         return defer.promise;
      };

      /**
       *  Un-execute the set scene type command.
       *  @function unExecute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to un-execute.
       *  @memberof tscml.SetSceneTypeCommand
       *  @return {Object} Q Promise that resolves when the command has been successfully undone.
       */
      _public.unExecute = function (commandHelper) {
         var defer = Q.defer();

         if (typeof _previousType != "undefined") {
            try {
               var sceneCommandInterface = commandHelper.getCommandInterface(scene);
               sceneCommandInterface.setType(_previousType, {themeables: _previousThemeables});
               defer.resolve();
            } catch (error) {
               defer.reject(error);
            }
         } else {
            defer.resolve();
         }

         return defer.promise;
      };

      return _public;
   };

   return {
      /**
       *  Factory method that returns a new SetSceneTypeCommand object.
       *  @function create
       *  @memberof tscml.SetSceneTypeCommand
       *  @param {tscml.Scene} scene - Scene to change type of.
       *  @param {String} type - Scene type to change to.
       *  @static
       *  @return {tscml.SetSceneTypeCommand} new SetSceneTypeCommand instance
       */
      create: function (scene, type) {
         return new SetSceneTypeCommand(scene, type);
      }
   };
});

(function (root, removeSceneSourceCommandFactory) {
   "use strict";

   var Q = (typeof exports !== 'undefined') ? require("q") : root.Q;
   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.RemoveSceneSourceCommand = removeSceneSourceCommandFactory(root, Q, namespace.commandNames);

})(this, function (root, Q, commandNames) {

   "use strict";

   /**
    * @memberof tscml
    * @class RemoveSceneSourceCommand
    * @param {tscml.Scene} scene - Reference to the scene to execute command on.
    * @param {String} uri - Uri of the source to remove.
    * @classdesc Removes a source from a scene.
    */
   var RemoveSceneSourceCommand = function (scene, uri) {
      var _commandName,
         _removedSource,
         _public;

      _commandName = commandNames.REMOVE_SCENE_SOURCE;

      _public = Object.defineProperties({}, {
         commandName: {
            value: _commandName
         }
      });

      /**
       *  Execute the remove scene source command
       *  @function execute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to execute.
       *  @memberof tscml.RemoveSceneSourceCommand
       *  @return {Object} Q Promise that resolves with the removed Source.
       */
      _public.execute = function (commandHelper) {
         var defer = Q.defer();

         try {
            var sceneCommandInterface = commandHelper.getCommandInterface(scene);
            for (var i = 0; i < scene.sources.length; i++) {
               if (scene.sources[i].uri === uri) {
                  _removedSource = sceneCommandInterface.removeSource(scene.sources[i]);
               }
            }
            defer.resolve();
         } catch (error) {
            defer.reject(error);
         }

         return defer.promise;
      };

      /**
       *  Un-execute the remove scene source command
       *  @function unExecute
       *  @param {Object} commandHelper - Object the command will use to get information it will need to un-execute.
       *  @memberof tscml.RemoveSceneSourceCommand
       *  @return {Object} Q Promise that resolves when the command is successfully undone.
       */
      _public.unExecute = function (commandHelper) {
         var defer = Q.defer();

         if (_removedSource) {
            try {
               var sceneCommandInterface = commandHelper.getCommandInterface(scene);
               sceneCommandInterface.addSource(_removedSource);
               defer.resolve();
            } catch (error) {
               defer.reject(error);
            }
         } else {
            defer.resolve();
         }

         return defer.promise;
      };

      return _public;
   };

   return {
      /**
       *  Factory method that returns a new RemoveSceneSourceCommand object.
       *  @function create
       *  @memberof tscml.RemoveSceneSourceCommand
       *  @param {tscml.Scene} scene - Reference to the scene to execute command on.
       *  @param {String} uri - Uri of the source to remove.
       *  @static
       *  @return {tscml.RemoveSceneSourceCommand} new RemoveSceneSourceCommand instance
       */
      create: function (scene, uri) {
         if (scene.type !== "content") {
            throw new Error("RemoveSceneSourceCommand: Scene of type(" + scene.type + ") does not support this command.");
         }
         return new RemoveSceneSourceCommand(scene, uri);
      }
   };

});

(function (root, fileVersionUpdaterFactory) {
   "use strict";

   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.FileVersionUpdater = fileVersionUpdaterFactory(root, namespace.idGenerator, namespace.sceneType);

})(this, function (root, idGenerator, sceneType) {
   /**
    * @memberof tscml
    * @class FileVersionUpdater
    * @classdesc Knows how to update versions of file format.
    */
   var updateV01ToV02 = function (projectJson) {
      if (projectJson.hasOwnProperty('themeFile') && typeof projectJson.themeFile === 'string') {
         projectJson.themeFile = {
            uri: projectJson.themeFile,
            mimeType: 'application/json'
         };
      } else if (!projectJson.hasOwnProperty('themeFile')) {
         projectJson.themeFile = {
            uri: "",
            mimeType: 'application/json'
         };
      }
      projectJson.themeFile.id = idGenerator.registerObject(projectJson.themeFile.id);

      // give scenes without a type a type of 'content'
      var scenesNode = getAllNodesWithName(projectJson, 'scenes');
      if (scenesNode.length === 1) {
         scenesNode[0].forEach(function (sceneNode) {
            if (!sceneNode.hasOwnProperty('type')) {
               sceneNode.type = sceneType.CONTENT;
            }
         });
      }

      // nothing to do for scene titles
      // other spec changes were either new optional fields to be added and set or related to theme

      projectJson.version = "0.2";
      return true;
   };

   var updateV02ToV03 = function (projectJson) {
      // spec changes had no properties needing updating

      projectJson.version = "0.3";
      return true;
   };

   var updateV03ToV04 = function (projectJson) {
      // spec changes had no properties needing updating

      projectJson.version = "0.4";
      return true;
   };

   var updateV04ToV06 = function (projectJson) {
      // spec changes had no properties needing updating

      projectJson.version = "0.6";
      return true;
   };

   var getAllNodesWithName = function (theObject, nodeName) {
      var foundNodes = [];
      for (var property in theObject) {
         if (theObject.hasOwnProperty(property)) {
            if (property === nodeName) {
               foundNodes.push(theObject[nodeName]);
            } else if (typeof theObject[property] === 'object') {
               foundNodes = foundNodes.concat(getAllNodesWithName(theObject[property], nodeName));
            }
         }
      }
      return foundNodes;
   };

   return {
      /**
       *  Factory method that updates from v0.1 to v0.2.
       *  @function updateV01ToV02
       *  @memberof tscml.FileVersionUpdater
       *  @param {string} projectJson - project data as Json.
       *  @static
       *  @return {Boolean} true if updated, false if not
       */
      updateV01ToV02: function (projectJson) {
         return updateV01ToV02(projectJson);
      },
      /**
       *  Factory method that updates from v0.2 to v0.3.
       *  @function updateV02ToV03
       *  @memberof tscml.FileVersionUpdater
       *  @param {string} projectJson - project data as Json.
       *  @static
       *  @return {Boolean} true if updated, false if not
       */
      updateV02ToV03: function (projectJson) {
         return updateV02ToV03(projectJson);
      },
      /**
       *  Factory method that updates from v0.3 to v0.4.
       *  @function updateV03ToV04
       *  @memberof tscml.FileVersionUpdater
       *  @param {string} projectJson - project data as Json.
       *  @static
       *  @return {Boolean} true if updated, false if not
       */
      updateV03ToV04: function (projectJson) {
         return updateV03ToV04(projectJson);
      },
      /**
       *  Factory method that updates from v0.4 to v0.6.
       *  @function updateV04ToV06
       *  @memberof tscml.FileVersionUpdater
       *  @param {string} projectJson - project data as Json.
       *  @static
       *  @return {Boolean} true if updated, false if not
       */
      updateV04ToV06: function (projectJson) {
         return updateV04ToV06(projectJson);
      }
   };

});

(function (root, fileVersioningFactory) {
   "use strict";

   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.FileVersioning = fileVersioningFactory(root, namespace.FileVersionUpdater);

})(this, function (root, fileVersionUpdater) {
   /**
    * @memberof tscml
    * @class FileVersioning
    * @classdesc Knows about current file version and how to update to current.
    */
   var CURRENT_FILE_VERSION = "0.6";

   // from http://stackoverflow.com/questions/6832596/how-to-compare-software-version-number-using-js-only-number
   var versionCompare = function (v1, v2, options) {
      var lexicographical = options && options.lexicographical,
         zeroExtend = options && options.zeroExtend,
         v1parts = v1.split('.'),
         v2parts = v2.split('.');

      function isValidPart(x) {
         return (lexicographical ? /^\d+[A-Za-z]*$/ : /^\d+$/).test(x);
      }

      if (!v1parts.every(isValidPart) || !v2parts.every(isValidPart)) {
         return NaN;
      }

      if (zeroExtend) {
         while (v1parts.length < v2parts.length) v1parts.push("0");
         while (v2parts.length < v1parts.length) v2parts.push("0");
      }

      if (!lexicographical) {
         v1parts = v1parts.map(Number);
         v2parts = v2parts.map(Number);
      }

      for (var i = 0; i < v1parts.length; ++i) {
         if (v2parts.length == i) {
            return 1;
         }

         if (v1parts[i] == v2parts[i]) {
            continue;
         }
         else if (v1parts[i] > v2parts[i]) {
            return 1;
         }
         else {
            return -1;
         }
      }

      if (v1parts.length != v2parts.length) {
         return -1;
      }

      return 0;
   };

   var checkUpdate = function (projectJson) {
      if (!projectJson.hasOwnProperty('version')) {
         projectJson.version = "0.1";
      }
      if (versionCompare(projectJson.version, CURRENT_FILE_VERSION) === 0) {
         return false;
      }

      // this series of if statements will continue to build and get long, that's just how it works
      if (versionCompare(projectJson.version, "0.2") < 0) {
         fileVersionUpdater.updateV01ToV02(projectJson);
      }
      if (versionCompare(projectJson.version, "0.3") < 0) {
         fileVersionUpdater.updateV02ToV03(projectJson);
      }
      if (versionCompare(projectJson.version, "0.4") < 0) {
         fileVersionUpdater.updateV03ToV04(projectJson);
      }
      if (versionCompare(projectJson.version, "0.6") < 0) {
         fileVersionUpdater.updateV04ToV06(projectJson);
      }

      return true;
   };

   var fileVersioning = Object.defineProperties({},
      {
         /**
          *  @public
          *  @readonly
          *  @memberof tscml.FileVersioning
          *  @property {String} the current version of the file format.
          */
         currentVersion: {
            value: CURRENT_FILE_VERSION
         }
      }
   );

   /**
    *  Updates the passed in project JSON to new version.
    *  @function checkUpdate
    *  @memberof tscml.FileVersioning
    *  @param {tscml.Project} project - Project instance reference.
    *  @static
    *  @return {Boolean} true if updated, false if not
    */
   fileVersioning.checkUpdate = function (project) {
      return checkUpdate(project);
   };

   return fileVersioning;
});

(function (root, sourceParserFactory) {
   "use strict";

   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.SourceParser = sourceParserFactory(root, namespace.Source, namespace.AdditionalPropertyHelper);

})(this, function (root, Source, AdditionalPropertyHelper) {

   "use strict";

   /**
    * @memberof tscml
    * @class SourceParser
    * @classdesc Parse Source JSON
    */
   var SourceParser = function (projectSignature) {
      return {
         /**
          *  Create a new Source from JSON
          *  @memberof tscml.SourceParser
          *  @function fromJSON
          *  @param {Object} sourceJson - Source JSON
          *  @param {Number} duration - Duration value from the Scene.
          *  @return {tscml.Source} A new Source Object
          */
         fromJSON: function (sourceJson, duration) {
            if (typeof sourceJson != "object" || typeof sourceJson != "object" || typeof sourceJson.uri == "undefined" || typeof sourceJson.mimeType == "undefined") {
               throw new Error("SourceParser: failed to parse source: expected {uri:'', mimeType:''}, but got: ", sourceJson);
            } else if (typeof duration == "undefined") {
               throw new Error("SourceParser: failed to parse source, missing duration.");
            }

            var sourceParams = {
               id: sourceJson.id,
               uri: sourceJson.uri,
               duration: duration,
               mimeType: sourceJson.mimeType,
               projectSignature: projectSignature
            };

            var source = Source.create(sourceParams);
            var sourceCommandInterface = source.getCommandInterface(projectSignature);

            var handledProperties = ['id', 'uri', 'duration', 'mimeType'];
            AdditionalPropertyHelper.parseAdditionalProperties(handledProperties, sourceJson, sourceCommandInterface.addAdditionalProperty);

            return source;
         }
      };
   };

   return {
      /**
       *  Factory method that returns a new SourceParser object.
       *  @function create
       *  @memberof tscml.SourceParser
       *  @static
       *  @return {tscml.SourceParser} new SourceParser instance
       */
      create: function (projectSignature) {
         return new SourceParser(projectSignature);
      }
   };
});

(function (root, sceneParserFactory) {
   "use strict";

   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.SceneParser = sceneParserFactory(root, namespace.Scene, namespace.SourceParser, namespace.AdditionalPropertyHelper);

})(this, function (root, Scene, SourceParser, AdditionalPropertyHelper) {

   "use strict";

   /**
    * @memberof tscml
    * @class SceneParser
    * @param {tscml.SceneTrack} sceneTrack - sceneTrack instance reference.
    * @param {Number} projectSignature - Project signature used to control access to command interface.
    * @param {Function} eventDispatcherFactory - Factory method to get new event dispatcher.
    * @classdesc Create Scene from JSON
    */
   var SceneParser = function (sceneTrack, projectSignature, eventDispatcherFactory) {
      return {
         /**
          *  Create a new Scene from JSON
          *  @memberof tscml.SceneParser
          *  @function fromJSON
          *  @param {Object} sceneJson - Scene JSON
          *  @return {tscml.Scene} A new Scene Object
          */
         fromJSON: function (sceneJson) {
            if (typeof sceneJson != "object") {
               throw new Error("SceneParser: failed to parse scene: expected a sceneJson.scene object, but got: ", sceneJson);
            } else if ((sceneJson.type === "content") && !(typeof sceneJson.flattenedSources == "object" && sceneJson.flattenedSources instanceof Array)) {
               throw new Error("SceneParser: failed to parse scene: expected an array of flattenedSources for scene of type 'content'.");
            } else if (typeof sceneJson.duration == "undefined") {
               throw new Error("SceneParser: failed to parse scene: missing scene duration.");
            }

            var sceneParams = {
               id: sceneJson.id,
               type: sceneJson.type,
               title: sceneJson.title,
               duration: sceneJson.duration,
               sceneTrack: sceneTrack,
               projectSignature: projectSignature,
               eventDispatcherFactory: eventDispatcherFactory
            };

            if (sceneJson.themeables) {
               sceneParams.themeables = sceneJson.themeables;
            }

            var scene = Scene.create(sceneParams);

            var sceneCommandInterface = scene.getCommandInterface(projectSignature);
            if (scene.type === "content") {
               var sourceParser = SourceParser.create(projectSignature);
               sceneJson.flattenedSources.forEach(function (sourceJson) {
                  var source = sourceParser.fromJSON(sourceJson, sceneJson.duration);
                  sceneCommandInterface.addSource(source);
               });
            }

            if(sceneJson.audioNarration !== undefined) {
               sceneCommandInterface.setAudioNarration(sceneJson.audioNarration);
            }

            var handledProperties = ['id', 'type', 'title', 'duration', 'themeables', 'flattenedSources', 'audioNarration'];
            AdditionalPropertyHelper.parseAdditionalProperties(handledProperties, sceneJson, sceneCommandInterface.addAdditionalProperty);

            return scene;
         }
      };
   };

   return {
      /**
       *  Factory method that returns a new SceneParser object.
       *  @function create
       *  @memberof tscml.SceneParser
       *  @param {tscml.SceneTrack} sceneTrack - SceneTrack instance reference.
       *  @param {Number} projectSignature - Project signature used to control access to command interface.
       *  @param {Function} eventDispatcherFactory - Factory method to get new event dispatcher.
       *  @static
       *  @return {tscml.SceneParser} new SceneParser instance
       */
      create: function (sceneTrack, projectSignature, eventDispatcherFactory) {
         return new SceneParser(sceneTrack, projectSignature, eventDispatcherFactory);
      }
   };
});

(function (root, sceneTrackParserFactory) {
   "use strict";

   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.SceneTrackParser = sceneTrackParserFactory(root, namespace.SceneTrack, namespace.SceneParser, namespace.AdditionalPropertyHelper);

})(this, function (root, SceneTrack, SceneParser, AdditionalPropertyHelper) {

   "use strict";

   /**
    * @memberof tscml
    * @class SceneTrackParser
    * @param {tscml.Timeline} timeline - timeline instance reference.
    * @param {Number} projectSignature - Project signature used to control access to command interface.
    * @param {Function} eventDispatcherFactory - Factory method to get new event dispatcher.
    * @classdesc Create a Scene Track from JSON
    */
   var SceneTrackParser = function (timeline, projectSignature, eventDispatcherFactory) {
      return {
         /**
          *  Create a new SceneTrack from JSON
          *  @memberof tscml.SceneTrackParser
          *  @function fromJSON
          *  @param {Object} sceneTrackJson - SceneTrack JSON
          *  @return {tscml.SceneTrack} A new SceneTrack Object
          */
         fromJSON: function (sceneTrackJson) {
            if (typeof sceneTrackJson != "object") {
               throw new Error("SceneTrackParser: failed to parse sceneTrack: expected {}, but got: ", sceneTrackJson);
            } else if (!(typeof sceneTrackJson.scenes == "object" && sceneTrackJson.scenes instanceof Array)) {
               throw new Error("SceneTrackParser: failed to parse sceneTrack: expected an array of scenes.");
            }

            var sceneTrackParams = {
               timeline: timeline,
               projectSignature: projectSignature,
               eventDispatcherFactory: eventDispatcherFactory
            };

            var sceneTrack = SceneTrack.create(sceneTrackParams);
            var sceneTrackCommandInterface = sceneTrack.getCommandInterface(projectSignature);
            var sceneParser = SceneParser.create(sceneTrack, projectSignature, eventDispatcherFactory);

            sceneTrackJson.scenes.forEach(function (sceneJson) {
               var scene = sceneParser.fromJSON(sceneJson);
               sceneTrackCommandInterface.appendScene(scene);
            });

            var handledProperties = ['scenes'];
            AdditionalPropertyHelper.parseAdditionalProperties(handledProperties, sceneTrackJson, sceneTrackCommandInterface.addAdditionalProperty);

            return sceneTrack;
         }
      };
   };

   return {
      /**
       *  Factory method that returns a new SceneTrackParser object.
       *  @function create
       *  @memberof tscml.SceneTrackParser
       *  @param {tscml.Timeline} timeline - Timeline instance reference.
       *  @param {Number} projectSignature - Project signature used to control access to command interface.
       *  @param {Function} eventDispatcherFactory - Factory method to get new event dispatcher.
       *  @static
       *  @return {tscml.SceneTrackParser} new SceneTrackParser instance
       */
      create: function (timeline, projectSignature, eventDispatcherFactory) {
         return new SceneTrackParser(timeline, projectSignature, eventDispatcherFactory);
      }
   };

});

(function (root, timelineParserFactory) {
   "use strict";

   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.TimelineParser = timelineParserFactory(root, namespace.Timeline, namespace.SceneTrackParser, namespace.AdditionalPropertyHelper);

})(this, function (root, Timeline, SceneTrackParser, AdditionalPropertyHelper) {

   "use strict";

   /**
    * @memberof tscml
    * @class TimelineParser
    * @param {tscml.Project} project - project instance reference.
    * @param {Number} projectSignature - Project signature used to control access to command interface.
    * @param {Function} eventDispatcherFactory - Factory method to get new event dispatcher.
    * @classdesc Create a Timeline from JSON
    */
   var TimelineParser = function (project, projectSignature, eventDispatcherFactory) {
      return {
         /**
          *  Create a new Timeline from JSON
          *  @memberof tscml.TimelineParser
          *  @function fromJSON
          *  @param {Object} timelineJson - timeline JSON
          *  @return {tscml.Timeline} A new Timeline Object
          */
         fromJSON: function (timelineJson) {
            if (typeof timelineJson != "object" || typeof timelineJson.sceneTrack != "object") {
               throw new Error("TimelineParser: failed to parse the timeline: expected {sceneTrack:{}}, but got: ", timelineJson);
            }

            var timelineParams = {
               id: timelineJson.id,
               project: project,
               projectSignature: projectSignature,
               eventDispatcherFactory: eventDispatcherFactory
            };

            var timeline = Timeline.create(timelineParams);
            var timelineCommandInterface = timeline.getCommandInterface(projectSignature);
            var sceneTrackParser = SceneTrackParser.create(timeline, projectSignature, eventDispatcherFactory);

            timelineCommandInterface.addSceneTrack(sceneTrackParser.fromJSON(timelineJson.sceneTrack));

            var handledProperties = ['id', 'sceneTrack'];
            AdditionalPropertyHelper.parseAdditionalProperties(handledProperties, timelineJson, timelineCommandInterface.addAdditionalProperty);

            return timeline;
         }
      };
   };

   return {
      /**
       *  Factory method that returns a new TimelineParser object.
       *  @function create
       *  @memberof tscml.TimelineParser
       *  @param {tscml.Project} project - Project instance reference.
       *  @param {Number} projectSignature - Project signature used to control access to command interface.
       *  @param {Function} eventDispatcherFactory - Factory method to get new event dispatcher.
       *  @static
       *  @return {tscml.TimelineParser} new TimelineParser instance
       */
      create: function (project, projectSignature, eventDispatcherFactory) {
         return new TimelineParser(project, projectSignature, eventDispatcherFactory);
      }
   };
});

(function (root, projectParserFactory) {
   "use strict";

   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.ProjectParser = projectParserFactory(root, namespace.TimelineParser, namespace.FileVersioning, namespace.AdditionalPropertyHelper);

})(this, function (root, TimelineParser, FileVersioning, AdditionalPropertyHelper) {

   "use strict";

   /**
    * @memberof tscml
    * @class ProjectParser
    * @param {tscml.Project} project - Project reference.
    * @param {Number} projectSignature - Project signature produced to control access.
    * @param {Function} eventDispatcherFactory - Factory method to get new event dispatcher.
    * @classdesc Parses the json data and builds the timeline elements.
    */
   var ProjectParser = function (project, projectSignature, eventDispatcherFactory) {

      return {
         /**
          *  Creates new project from JSON
          *  @memberof tscml.ProjectParser
          *  @function fromJSON
          *  @param {Object} projectJson - project JSON
          */
         fromJSON: function (projectJson) {
            if (typeof projectJson != "object" || typeof projectJson.timeline != "object") {
               throw new Error("ProjectParser: failed to parse project: expected {timeline:{}}, but got: ", projectJson);
            }
            FileVersioning.checkUpdate(projectJson);

            project.title = projectJson.title || "";
            project.description = projectJson.description || "";
            project.author = projectJson.author || "";
            project.width = projectJson.width || "";
            project.height = projectJson.height || "";
            project.version = projectJson.version || "0.1";

            var timelineParser = TimelineParser.create(project, projectSignature, eventDispatcherFactory);
            var timeline = timelineParser.fromJSON(projectJson.timeline);

            var projectCommandInterface = project.getCommandInterface(projectSignature);
            projectCommandInterface.addTimeline(timeline);

            if (projectJson.hasOwnProperty("metadata") && typeof projectJson.metadata === "object") {
               for (var prop in projectJson.metadata) {
                  if (projectJson.metadata.hasOwnProperty(prop)) {
                     projectCommandInterface.setMetadataValue(prop, projectJson.metadata[prop]);
                  }
               }
            }

            var handledProperties = ['title', 'description', 'author', 'width', 'height', 'timeline', 'metadata', 'themeFile', 'version'];
            AdditionalPropertyHelper.parseAdditionalProperties(handledProperties, projectJson, projectCommandInterface.addAdditionalProperty);

            projectCommandInterface.setThemeFile(projectJson.themeFile.uri);
         }
      };
   };

   return {
      /**
       *  Factory method that returns a new ProjectParser object.
       *  @function create
       *  @memberof tscml.ProjectParser
       *  @param {tscml.Project} project - Project instance reference.
       *  @param {Number} projectSignature - Project signature used to control access to command interface.
       *  @param {Function} eventDispatcherFactory - Factory method to get new event dispatcher.
       *  @static
       *  @return {tscml.ProjectParser} new ProjectParser instance
       */
      create: function (project, projectSignature, eventDispatcherFactory) {
         return new ProjectParser(project, projectSignature, eventDispatcherFactory);
      }
   };

});

(function (root, projectFactory) {
   "use strict";

   var namespace = (typeof exports !== 'undefined') ? module.exports : (root.tscml = root.tscml || {});
   namespace.Project = projectFactory(root, namespace.projectSignatureGenerator, namespace.idGenerator, namespace.ProjectParser, namespace.CommandHistory, namespace.Timeline, namespace.EventNotificationBundler, namespace.FileVersioning, namespace.AdditionalPropertyHelper);

})(this, function (root, projectSignatureGenerator, idGenerator, ProjectParser, CommandHistory, Timeline, EventNotificationBundler, FileVersioning, AdditionalPropertyHelper) {

   "use strict";

   /**
    * Theme file changed event fires when the theme file value has changed.
    * @event tscml.Project#themeFileChanged
    * @type {object}
    * @property {String} type - Event name
    * @property {String} themeFile - New themeFile value.
    */

   /**
    * @memberof tscml
    * @class Project
    * @classdesc Top-level object representing a project.
    * @param {Number} generatedProjectSignature - internal signature.
    * @param {Object} eventNotificationBundler - Event Notification Bundler object.
    * @fires tscml.Project#themeFileChanged
    */
   var Project = function (generatedProjectSignature, eventNotificationBundler) {
      var _title,
         _description,
         _author,
         _width,
         _height,
         _timeline,
         _metadata,
         _version,
         _statLoaderList,
         _commandHistory,
         _themeFile,
         _additionalProperties,
         _eventDispatcher,
         _public;

      _title = "";
      _description = "";
      _author = "";
      _width = "100%";
      _height = "100%";
      _themeFile = {
         uri: "",
         mimeType: "application/json"
      };
      _metadata = {};
      _themeFile.id = idGenerator.registerObject(_themeFile.id);
      _version = FileVersioning.currentVersion;
      _additionalProperties = {};
      _statLoaderList = [];
      _eventDispatcher = eventNotificationBundler.eventDispatcherFactory();
      _commandHistory = new CommandHistory(generatedProjectSignature, _statLoaderList, eventNotificationBundler);

      var addTimeline = function (timeline) {
         if (timeline) {
            _timeline = timeline;
         } else {
            var timelineParams = {
               project: _public,
               projectSignature: generatedProjectSignature,
               eventDispatcherFactory: eventNotificationBundler.eventDispatcherFactory
            };
            _timeline = Timeline.create(timelineParams);
            _timeline.getCommandInterface(generatedProjectSignature).addSceneTrack();
         }
      };

      var setMetadataValue = function(key, value) {
         if (value === null) {
            delete _metadata[key];
         } else {
            _metadata[key] = value;
         }
      };

      var setThemeFile = function (themeFileUri) {
         _themeFile.uri = themeFileUri;
         _eventDispatcher.trigger("themeFileChanged", {themeFile: _themeFile});
      };

      var addAdditionalProperty = function (name, value) {
         _additionalProperties[name] = value;
      };

      _public = Object.defineProperties({},
         {
            /**
             *  @public
             *  @readonly
             *  @memberof tscml.Project
             *  @property {tscml.Timeline} timeline - Timeline for a project.
             */
            timeline: {
               get: function () {
                  return _timeline;
               }
            },
            /**
             *  @public
             *  @memberof tscml.Project
             *  @property {String} title - Title of the project.
             */
            title: {
               get: function () {
                  return _title;
               },
               set: function (value) {
                  _title = value;
               }
            },
            /**
             *  @public
             *  @memberof tscml.Project
             *  @property {String} description - Description of the project.
             */
            description: {
               get: function () {
                  return _description;
               },
               set: function (value) {
                  _description = value;
               }
            },
            /**
             *  @public
             *  @memberof tscml.Project
             *  @property {String} author - Author of the project.
             */
            author: {
               get: function () {
                  return _author;
               },
               set: function (value) {
                  _author = value;
               }
            },
            /**
             *  @public
             *  @memberof tscml.Project
             *  @property {String} width - Width of the project.
             */
            width: {
               get: function () {
                  return _width;
               },
               set: function (value) {
                  _width = value;
               }
            },
            /**
             *  @public
             *  @memberof tscml.Project
             *  @property {String} height - Height of the project.
             */
            height: {
               get: function () {
                  return _height;
               },
               set: function (value) {
                  _height = value;
               }
            },
            /**
             *  @public
             *  @readonly
             *  @memberof tscml.Project
             *  @property {String} themeFile - Theme file for the project.
             */
            themeFile: {
               get: function () {
                  return _themeFile;
               }
            },
            /**
             *  @public
             *  @memberof tscml.Project
             *  @property {String} version - Version for the project fileformat.
             */
            version: {
               get: function () {
                  return _version;
               },
               set: function (value) {
                  _version = value;
               }
            }
         }
      );

      /**
       *  Get an object with access to a Project manipulation methods.  This is used internally within Media Lib.
       *  @memberof tscml.Project
       *  @function getCommandInterface
       *  @param {Number} projectSignature - Project signature produced to control access.
       *  @return {Object}
       */
      _public.getCommandInterface = function (projectSignature) {
         if (generatedProjectSignature !== projectSignature) {
            throw new Error("Tried to get command interface with invalid project signature");
         }
         return {
            addTimeline: addTimeline,
            setMetadataValue: setMetadataValue,
            setThemeFile: setThemeFile,
            addAdditionalProperty: addAdditionalProperty
         };
      };

      /**
       *  Add a callback function for an event.
       *  @memberof tscml.Project
       *  @function on
       *  @param {String} eventName - Name of event to listen for.
       *  @param {Function} callback - Callback function for event.
       *  @listens tscml.Project#themeFileChanged
       */
      _public.on = _eventDispatcher.on;

      /**
       *  Remove a callback function for an event.
       *  @memberof tscml.Project
       *  @function off
       *  @param {String} eventName - Name of event to listen for.
       *  @param {Function} callback - Callback function for event.
       */
      _public.off = _eventDispatcher.off;

      /**
       *  Retrieve a metadata value by key from a project
       *  @function getMetadataValue
       *  @param {string} key - the key for the metadata value you are trying to retrieve
       *  @return {*} value - the value associated with the key requested (usually a string, null if key/value pair does not exist)
       *  @memberof tscml.Project
       */
      _public.getMetadataValue = function (key) {
         return _metadata.hasOwnProperty(key) ? _metadata[key] : null;
      };

      /**
       *  Add a statLoader from the Project
       *  @function addStatLoader
       *  @param {Object} statLoader - State loader object that implements the required methods.
       *  @example
       *  var simpleStatLoader = {};
       *  simpleStatLoader.canHandleUri = function(uri, successCallback, errorCallback) {
       *     // call successCallback with true or false
       *  };
       *  simpleStatLoader.getInformationForUri = function(uri, successCallback, errorCallback) {
       *     // calls successCallback with {duration:{Number}, mimeType:"{String}"};
       *  };

       *  var project = tscml.Project.create();
       *  project.addStatLoader(simpleStatLoader);
       *  @memberof tscml.Project
       */
      _public.addStatLoader = function (statLoader) {
         if (typeof statLoader != "object" || typeof statLoader.canHandleUri != "function" || typeof statLoader.getInformationForUri != "function") {
            throw new Error("Project.addStatLoader: Supplied state loader is not valid.");
         }
         _statLoaderList.push(statLoader);
      };

      /**
       *  Remove a statLoader from the Project
       *  @function removeStatLoader
       *  @param {Object} statLoader - State Loader object.
       *  @memberof tscml.Project
       *  @return {Object} Removed Stat Loader
       */
      _public.removeStatLoader = function (statLoader) {
         for (var i = 0, numStatLoaders = _statLoaderList.length; i < numStatLoaders; i++) {
            if (_statLoaderList[i] === statLoader) {
               return _statLoaderList.splice(i, 1)[0];
            }
         }
      };

      /**
       *  Will execute a command on the project.
       *  @function executeCommand
       *  @param {Object} command - Command to execute.
       *  @memberof tscml.Project
       *  @return {Object} Q Promise resolving with the result of executing the command.
       *  @example
       *  var project = tscml.Project.create();
       *  var insertSceneCommand = tscml.InsertSceneCommand.create(project.timeline.sceneTrack, 0);
       *  project.executeCommand(insertSceneCommand).then(function(insertedScene) {
       *        // command succeeded
       *     },
       *     function(error) {
       *        // command failed.
       *     }
       *  );
       */
      _public.executeCommand = function (command) {
         return _commandHistory.execute(command);
      };

      /**
       *  Will undo the last command executed.
       *  @function undo
       *  @memberof tscml.Project
       *  @return {Object} Q Promise that resolves when the command has been successfully undone.
       *  @example
       *  project.undo().then(function(result) {
       *        // undo succeeded
       *     },
       *     function(error) {
       *        // undo failed.
       *     }
       *  );
       */
      _public.undo = function () {
         return _commandHistory.undo();
      };

      /**
       *  Will redo the last command executed.
       *  @function redo
       *  @memberof tscml.Project
       *  @return {Object} Q Promise resolving with the result of executing the command.
       *  @example
       *  project.redo().then(function(result) {
       *        // redo succeeded
       *     },
       *     function(error) {
       *        // redo failed.
       *     }
       *  );
       */
      _public.redo = function () {
         return _commandHistory.redo();
      };

      /**
       *  Will return the JSON for the Project
       *  @function toJSON
       *  @memberof tscml.Project
       *  @return {Object} Project JSON
       */
      _public.toJSON = function () {
         var json = {
            "title": _title,
            "description": _description,
            "author": _author,
            "height": _height,
            "width": _width,
            "themeFile": _themeFile,
            "timeline": _timeline.toJSON(),
            "metadata": _metadata,
            "version": _version
         };

         if (_additionalProperties) {
            AdditionalPropertyHelper.updatePropertiesOnObject(_additionalProperties, json);
         }

         return json;
      };

      return _public;
   };

   return {
      /**
       *  Factory method that returns a new Project.
       *  @function create
       *  @memberof tscml.Project
       *  @static
       *  @return {tscml.Project} new Project instance
       *  @example
       *  var project = tscml.Project.create();
       */
      create: function () {
         var projectSignature = projectSignatureGenerator.generate();
         var eventNotificationBundler = EventNotificationBundler.create();
         var project = new Project(projectSignature, eventNotificationBundler);
         var projectCommandInterface = project.getCommandInterface(projectSignature);
         projectCommandInterface.addTimeline();
         return project;
      },
      /**
       *  Factory method that returns a new Project created from project JSON.
       *  @function createFromJSON
       *  @memberof tscml.Project
       *  @param {Object} projectJson - Project JSON Object
       *  @static
       *  @return {tscml.Project} new Project instance
       *  @example
       *  var projectJson = JSON.parse(jsonString);
       *  var project = tscml.Project.createFromJSON(projectJson);
       */
      createFromJSON: function (projectJson) {
         var projectSignature = projectSignatureGenerator.generate();
         var eventNotificationBundler = EventNotificationBundler.create();
         var project = new Project(projectSignature, eventNotificationBundler);
         var parser = ProjectParser.create(project, projectSignature, eventNotificationBundler.eventDispatcherFactory);
         parser.fromJSON(projectJson);
         return project;
      }
   };

});
